(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.dayjs=e()}(this,function(){"use strict";var t="millisecond",e="second",n="minute",r="hour",i="day",s="week",u="month",a="quarter",o="year",f="date",h=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,c=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,d={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},$=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},l={s:$,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+$(r,2,"0")+":"+$(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,u),s=n-i<0,a=e.clone().add(r+(s?-1:1),u);return+(-(r+(n-i)/(s?i-a:a-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(h){return{M:u,y:o,w:s,d:i,D:f,h:r,m:n,s:e,ms:t,Q:a}[h]||String(h||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},y="en",M={};M[y]=d;var m=function(t){return t instanceof S},D=function(t,e,n){var r;if(!t)return y;if("string"==typeof t)M[t]&&(r=t),e&&(M[t]=e,r=t);else{var i=t.name;M[i]=t,r=i}return!n&&r&&(y=r),r||!n&&y},v=function(t,e){if(m(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new S(n)},g=l;g.l=D,g.i=m,g.w=function(t,e){return v(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var S=function(){function d(t){this.$L=D(t.locale,null,!0),this.parse(t)}var $=d.prototype;return $.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(g.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(h);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},$.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},$.$utils=function(){return g},$.isValid=function(){return!("Invalid Date"===this.$d.toString())},$.isSame=function(t,e){var n=v(t);return this.startOf(e)<=n&&n<=this.endOf(e)},$.isAfter=function(t,e){return v(t)<this.startOf(e)},$.isBefore=function(t,e){return this.endOf(e)<v(t)},$.$g=function(t,e,n){return g.u(t)?this[e]:this.set(n,t)},$.unix=function(){return Math.floor(this.valueOf()/1e3)},$.valueOf=function(){return this.$d.getTime()},$.startOf=function(t,a){var h=this,c=!!g.u(a)||a,d=g.p(t),$=function(t,e){var n=g.w(h.$u?Date.UTC(h.$y,e,t):new Date(h.$y,e,t),h);return c?n:n.endOf(i)},l=function(t,e){return g.w(h.toDate()[t].apply(h.toDate("s"),(c?[0,0,0,0]:[23,59,59,999]).slice(e)),h)},y=this.$W,M=this.$M,m=this.$D,D="set"+(this.$u?"UTC":"");switch(d){case o:return c?$(1,0):$(31,11);case u:return c?$(1,M):$(0,M+1);case s:var v=this.$locale().weekStart||0,S=(y<v?y+7:y)-v;return $(c?m-S:m+(6-S),M);case i:case f:return l(D+"Hours",0);case r:return l(D+"Minutes",1);case n:return l(D+"Seconds",2);case e:return l(D+"Milliseconds",3);default:return this.clone()}},$.endOf=function(t){return this.startOf(t,!1)},$.$set=function(s,a){var h,c=g.p(s),d="set"+(this.$u?"UTC":""),$=(h={},h[i]=d+"Date",h[f]=d+"Date",h[u]=d+"Month",h[o]=d+"FullYear",h[r]=d+"Hours",h[n]=d+"Minutes",h[e]=d+"Seconds",h[t]=d+"Milliseconds",h)[c],l=c===i?this.$D+(a-this.$W):a;if(c===u||c===o){var y=this.clone().set(f,1);y.$d[$](l),y.init(),this.$d=y.set(f,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},$.set=function(t,e){return this.clone().$set(t,e)},$.get=function(t){return this[g.p(t)]()},$.add=function(t,a){var f,h=this;t=Number(t);var c=g.p(a),d=function(e){var n=v(h);return g.w(n.date(n.date()+Math.round(e*t)),h)};if(c===u)return this.set(u,this.$M+t);if(c===o)return this.set(o,this.$y+t);if(c===i)return d(1);if(c===s)return d(7);var $=(f={},f[n]=6e4,f[r]=36e5,f[e]=1e3,f)[c]||1,l=this.$d.getTime()+t*$;return g.w(l,this)},$.subtract=function(t,e){return this.add(-1*t,e)},$.format=function(t){var e=this;if(!this.isValid())return"Invalid Date";var n=t||"YYYY-MM-DDTHH:mm:ssZ",r=g.z(this),i=this.$locale(),s=this.$H,u=this.$m,a=this.$M,o=i.weekdays,f=i.months,h=function(t,r,i,s){return t&&(t[r]||t(e,n))||i[r].substr(0,s)},d=function(t){return g.s(s%12||12,t,"0")},$=i.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:g.s(a+1,2,"0"),MMM:h(i.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:g.s(this.$D,2,"0"),d:String(this.$W),dd:h(i.weekdaysMin,this.$W,o,2),ddd:h(i.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:g.s(s,2,"0"),h:d(1),hh:d(2),a:$(s,u,!0),A:$(s,u,!1),m:String(u),mm:g.s(u,2,"0"),s:String(this.$s),ss:g.s(this.$s,2,"0"),SSS:g.s(this.$ms,3,"0"),Z:r};return n.replace(c,function(t,e){return e||l[t]||r.replace(":","")})},$.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},$.diff=function(t,f,h){var c,d=g.p(f),$=v(t),l=6e4*($.utcOffset()-this.utcOffset()),y=this-$,M=g.m(this,$);return M=(c={},c[o]=M/12,c[u]=M,c[a]=M/3,c[s]=(y-l)/6048e5,c[i]=(y-l)/864e5,c[r]=y/36e5,c[n]=y/6e4,c[e]=y/1e3,c)[d]||y,h?M:g.a(M)},$.daysInMonth=function(){return this.endOf(u).$D},$.$locale=function(){return M[this.$L]},$.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=D(t,e,!0);return r&&(n.$L=r),n},$.clone=function(){return g.w(this.$d,this)},$.toDate=function(){return new Date(this.valueOf())},$.toJSON=function(){return this.isValid()?this.toISOString():null},$.toISOString=function(){return this.$d.toISOString()},$.toString=function(){return this.$d.toUTCString()},d}(),p=S.prototype;return v.prototype=p,[["$ms",t],["$s",e],["$m",n],["$H",r],["$W",i],["$M",u],["$y",o],["$D",f]].forEach(function(t){p[t[1]]=function(e){return this.$g(e,t[0],t[1])}}),v.extend=function(t,e){return t.$i||(t(e,S,v),t.$i=!0),v},v.locale=D,v.isDayjs=m,v.unix=function(t){return v(1e3*t)},v.en=M[y],v.Ls=M,v.p={},v});

},{}],2:[function(require,module,exports){
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.dayjs_plugin_customParseFormat=e()}(this,function(){"use strict";var t={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},e=function(e,n){return e.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,function(e,r,i){var o=i&&i.toUpperCase();return r||n[i]||t[i]||n[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,function(t,e,n){return e||n.slice(1)})})},n=/(\[[^[]*\])|([-:/.()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,r=/\d\d/,i=/\d\d?/,o=/\d*[^\s\d-_:/()]+/,s={};var a=function(t){return function(e){this[t]=+e}},f=[/[+-]\d\d:?(\d\d)?/,function(t){(this.zone||(this.zone={})).offset=function(t){if(!t)return 0;var e=t.match(/([+-]|\d\d)/g),n=60*e[1]+(+e[2]||0);return 0===n?0:"+"===e[0]?-n:n}(t)}],u=function(t){var e=s[t];return e&&(e.indexOf?e:e.s.concat(e.f))},h=function(t,e){var n,r=s.meridiem;if(r){for(var i=1;i<=24;i+=1)if(t.indexOf(r(i,0,e))>-1){n=i>12;break}}else n=t===(e?"pm":"PM");return n},d={A:[o,function(t){this.afternoon=h(t,!1)}],a:[o,function(t){this.afternoon=h(t,!0)}],S:[/\d/,function(t){this.milliseconds=100*+t}],SS:[r,function(t){this.milliseconds=10*+t}],SSS:[/\d{3}/,function(t){this.milliseconds=+t}],s:[i,a("seconds")],ss:[i,a("seconds")],m:[i,a("minutes")],mm:[i,a("minutes")],H:[i,a("hours")],h:[i,a("hours")],HH:[i,a("hours")],hh:[i,a("hours")],D:[i,a("day")],DD:[r,a("day")],Do:[o,function(t){var e=s.ordinal,n=t.match(/\d+/);if(this.day=n[0],e)for(var r=1;r<=31;r+=1)e(r).replace(/\[|\]/g,"")===t&&(this.day=r)}],M:[i,a("month")],MM:[r,a("month")],MMM:[o,function(t){var e=u("months"),n=(u("monthsShort")||e.map(function(t){return t.substr(0,3)})).indexOf(t)+1;if(n<1)throw new Error;this.month=n%12||n}],MMMM:[o,function(t){var e=u("months").indexOf(t)+1;if(e<1)throw new Error;this.month=e%12||e}],Y:[/[+-]?\d+/,a("year")],YY:[r,function(t){t=+t,this.year=t+(t>68?1900:2e3)}],YYYY:[/\d{4}/,a("year")],Z:f,ZZ:f};var c=function(t,r,i){try{var o=function(t){for(var r=(t=e(t,s&&s.formats)).match(n),i=r.length,o=0;o<i;o+=1){var a=r[o],f=d[a],u=f&&f[0],h=f&&f[1];r[o]=h?{regex:u,parser:h}:a.replace(/^\[|\]$/g,"")}return function(t){for(var e={},n=0,o=0;n<i;n+=1){var s=r[n];if("string"==typeof s)o+=s.length;else{var a=s.regex,f=s.parser,u=t.substr(o),h=a.exec(u)[0];f.call(e,h),t=t.replace(h,"")}}return function(t){var e=t.afternoon;if(void 0!==e){var n=t.hours;e?n<12&&(t.hours+=12):12===n&&(t.hours=0),delete t.afternoon}}(e),e}}(r)(t),a=o.year,f=o.month,u=o.day,h=o.hours,c=o.minutes,m=o.seconds,l=o.milliseconds,M=o.zone,Y=new Date,v=u||(a||f?1:Y.getDate()),p=a||Y.getFullYear(),D=0;a&&!f||(D=f>0?f-1:Y.getMonth());var y=h||0,L=c||0,g=m||0,$=l||0;return M?new Date(Date.UTC(p,D,v,y,L,g,$+60*M.offset*1e3)):i?new Date(Date.UTC(p,D,v,y,L,g,$)):new Date(p,D,v,y,L,g,$)}catch(t){return new Date("")}};return function(t,e,n){n.p.customParseFormat=!0;var r=e.prototype,i=r.parse;r.parse=function(t){var e=t.date,r=t.utc,o=t.args;this.$u=r;var a=o[1];if("string"==typeof a){var f=!0===o[2],u=!0===o[3],h=f||u,d=o[2];u&&(d=o[2]),s=this.$locale(),!f&&d&&(s=n.Ls[d]),this.$d=c(e,a,r),this.init(),d&&!0!==d&&(this.$L=this.locale(d).$L),h&&e!==this.format(a)&&(this.$d=new Date("")),s={}}else if(a instanceof Array)for(var m=a.length,l=1;l<=m;l+=1){o[1]=a[l-1];var M=n.apply(this,o);if(M.isValid()){this.$d=M.$d,this.$L=M.$L,this.init();break}l===m&&(this.$d=new Date(""))}else i.call(this,t)}}});

},{}],3:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):e.dayjs_plugin_isSameOrBefore=t()}(this,function(){"use strict";return function(e,t){t.prototype.isSameOrBefore=function(e,t){return this.isSame(e,t)||this.isBefore(e,t)}}});

},{}],4:[function(require,module,exports){
!function(t,i){"object"==typeof exports&&"undefined"!=typeof module?module.exports=i():"function"==typeof define&&define.amd?define(i):t.dayjs_plugin_utc=i()}(this,function(){"use strict";return function(t,i,e){var s=i.prototype;e.utc=function(t){return new i({date:t,utc:!0,args:arguments})},s.utc=function(t){var i=e(this.toDate(),{locale:this.$L,utc:!0});return t?i.add(this.utcOffset(),"minute"):i},s.local=function(){return e(this.toDate(),{locale:this.$L,utc:!1})};var f=s.parse;s.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),f.call(this,t)};var n=s.init;s.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds()}else n.call(this)};var u=s.utcOffset;s.utcOffset=function(t,i){var e=this.$utils().u;if(e(t))return this.$u?0:e(this.$offset)?u.call(this):this.$offset;var s=Math.abs(t)<=16?60*t:t,f=this;if(i)return f.$offset=s,f.$u=0===t,f;if(0!==t){var n=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();(f=this.local().add(s+n,"minute")).$offset=s,f.$x.$localOffset=n}else f=this.utc();return f};var o=s.format;s.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return o.call(this,i)},s.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||(new Date).getTimezoneOffset());return this.$d.valueOf()-6e4*t},s.isUTC=function(){return!!this.$u},s.toISOString=function(){return this.toDate().toISOString()},s.toString=function(){return this.toDate().toUTCString()};var r=s.toDate;s.toDate=function(t){return"s"===t&&this.$offset?e(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():r.call(this)};var a=s.diff;s.diff=function(t,i,s){if(t&&this.$u===t.$u)return a.call(this,t,i,s);var f=this.local(),n=e(t).local();return a.call(f,n,i,s)}}});

},{}],5:[function(require,module,exports){
(function (global){
(function(global) {
  /**
   * Polyfill URLSearchParams
   *
   * Inspired from : https://github.com/WebReflection/url-search-params/blob/master/src/url-search-params.js
   */

  var checkIfIteratorIsSupported = function() {
    try {
      return !!Symbol.iterator;
    } catch(error) {
      return false;
    }
  };


  var iteratorSupported = checkIfIteratorIsSupported();

  var createIterator = function(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return { done: value === void 0, value: value };
      }
    };

    if(iteratorSupported) {
      iterator[Symbol.iterator] = function() {
        return iterator;
      };
    }

    return iterator;
  };

  /**
   * Search param name and values should be encoded according to https://url.spec.whatwg.org/#urlencoded-serializing
   * encodeURIComponent() produces the same result except encoding spaces as `%20` instead of `+`.
   */
  var serializeParam = function(value) {
    return encodeURIComponent(value).replace(/%20/g, '+');
  };

  var deserializeParam = function(value) {
    return decodeURIComponent(value).replace(/\+/g, ' ');
  };

  var polyfillURLSearchParams= function() {

    var URLSearchParams = function(searchString) {
      Object.defineProperty(this, '_entries', { value: {} });

      if(typeof searchString === 'string') {
        if(searchString !== '') {
          searchString = searchString.replace(/^\?/, '');
          var attributes = searchString.split('&');
          var attribute;
          for(var i = 0; i < attributes.length; i++) {
            attribute = attributes[i].split('=');
            this.append(
              deserializeParam(attribute[0]),
              (attribute.length > 1) ? deserializeParam(attribute[1]) : ''
            );
          }
        }
      } else if(searchString instanceof URLSearchParams) {
        var _this = this;
        searchString.forEach(function(value, name) {
          _this.append(value, name);
        });
      }
    };

    var proto = URLSearchParams.prototype;

    proto.append = function(name, value) {
      if(name in this._entries) {
        this._entries[name].push(value.toString());
      } else {
        this._entries[name] = [value.toString()];
      }
    };

    proto.delete = function(name) {
      delete this._entries[name];
    };

    proto.get = function(name) {
      return (name in this._entries) ? this._entries[name][0] : null;
    };

    proto.getAll = function(name) {
      return (name in this._entries) ? this._entries[name].slice(0) : [];
    };

    proto.has = function(name) {
      return (name in this._entries);
    };

    proto.set = function(name, value) {
      this._entries[name] = [value.toString()];
    };

    proto.forEach = function(callback, thisArg) {
      var entries;
      for(var name in this._entries) {
        if(this._entries.hasOwnProperty(name)) {
          entries = this._entries[name];
          for(var i = 0; i < entries.length; i++) {
            callback.call(thisArg, entries[i], name, this);
          }
        }
      }
    };

    proto.keys = function() {
      var items = [];
      this.forEach(function(value, name) { items.push(name); });
      return createIterator(items);
    };

    proto.values = function() {
      var items = [];
      this.forEach(function(value) { items.push(value); });
      return createIterator(items);
    };

    proto.entries = function() {
      var items = [];
      this.forEach(function(value, name) { items.push([name, value]); });
      return createIterator(items);
    };

    if(iteratorSupported) {
      proto[Symbol.iterator] = proto.entries;
    }

    proto.toString = function() {
      var searchString = '';
      this.forEach(function(value, name) {
        if(searchString.length > 0) searchString+= '&';
        searchString += serializeParam(name) + '=' + serializeParam(value);
      });
      return searchString;
    };

    global.URLSearchParams = URLSearchParams;
  };

  if(!('URLSearchParams' in global) || (new URLSearchParams('?a=1').toString() !== 'a=1')) {
    polyfillURLSearchParams();
  }

  // HTMLAnchorElement

})(
  (typeof global !== 'undefined') ? global
    : ((typeof window !== 'undefined') ? window
    : ((typeof self !== 'undefined') ? self : this))
);

(function(global) {
  /**
   * Polyfill URL
   *
   * Inspired from : https://github.com/arv/DOM-URL-Polyfill/blob/master/src/url.js
   */

  var checkIfURLIsSupported = function() {
    try {
      var u = new URL('b', 'http://a');
      u.pathname = 'c%20d';
      return (u.href === 'http://a/c%20d') && u.searchParams;
    } catch(e) {
      return false;
    }
  };


  var polyfillURL = function() {
    var _URL = global.URL;

    var URL = function(url, base) {
      if(typeof url !== 'string') url = String(url);

      var doc = document.implementation.createHTMLDocument('');
      window.doc = doc;
      if(base) {
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
      }

      var anchorElement = doc.createElement('a');
      anchorElement.href = url;
      doc.body.appendChild(anchorElement);
      anchorElement.href = anchorElement.href; // force href to refresh

      if(anchorElement.protocol === ':' || !/:/.test(anchorElement.href)) {
        throw new TypeError('Invalid URL');
      }

      Object.defineProperty(this, '_anchorElement', {
        value: anchorElement
      });
    };

    var proto = URL.prototype;

    var linkURLWithAnchorAttribute = function(attributeName) {
      Object.defineProperty(proto, attributeName, {
        get: function() {
          return this._anchorElement[attributeName];
        },
        set: function(value) {
          this._anchorElement[attributeName] = value;
        },
        enumerable: true
      });
    };

    ['hash', 'host', 'hostname', 'port', 'protocol', 'search']
    .forEach(function(attributeName) {
      linkURLWithAnchorAttribute(attributeName);
    });

    Object.defineProperties(proto, {

      'toString': {
        get: function() {
          var _this = this;
          return function() {
            return _this.href;
          };
        }
      },

      'href' : {
        get: function() {
          return this._anchorElement.href.replace(/\?$/,'');
        },
        set: function(value) {
          this._anchorElement.href = value;
        },
        enumerable: true
      },

      'pathname' : {
        get: function() {
          return this._anchorElement.pathname.replace(/(^\/?)/,'/');
        },
        set: function(value) {
          this._anchorElement.pathname = value;
        },
        enumerable: true
      },

      'origin': {
        get: function() {
          // get expected port from protocol
          var expectedPort = {'http:': 80, 'https:': 443, 'ftp:': 21}[this._anchorElement.protocol];
          // add port to origin if, expected port is different than actual port
          // and it is not empty f.e http://foo:8080
          // 8080 != 80 && 8080 != ''
          var addPortToOrigin = this._anchorElement.port != expectedPort &&
            this._anchorElement.port !== ''

          return this._anchorElement.protocol +
            '//' +
            this._anchorElement.hostname +
            (addPortToOrigin ? (':' + this._anchorElement.port) : '');
        },
        enumerable: true
      },

      'password': { // TODO
        get: function() {
          return '';
        },
        set: function(value) {
        },
        enumerable: true
      },

      'username': { // TODO
        get: function() {
          return '';
        },
        set: function(value) {
        },
        enumerable: true
      },

      'searchParams': {
        get: function() {
          var searchParams = new URLSearchParams(this.search);
          var _this = this;
          ['append', 'delete', 'set'].forEach(function(methodName) {
            var method = searchParams[methodName];
            searchParams[methodName] = function() {
              method.apply(searchParams, arguments);
              _this.search = searchParams.toString();
            };
          });
          return searchParams;
        },
        enumerable: true
      }
    });

    URL.createObjectURL = function(blob) {
      return _URL.createObjectURL.apply(_URL, arguments);
    };

    URL.revokeObjectURL = function(url) {
      return _URL.revokeObjectURL.apply(_URL, arguments);
    };

    global.URL = URL;

  };

  if(!checkIfURLIsSupported()) {
    polyfillURL();
  }

  if((global.location !== void 0) && !('origin' in global.location)) {
    var getOrigin = function() {
      return global.location.protocol + '//' + global.location.hostname + (global.location.port ? (':' + global.location.port) : '');
    };

    try {
      Object.defineProperty(global.location, 'origin', {
        get: getOrigin,
        enumerable: true
      });
    } catch(e) {
      setInterval(function() {
        global.location.origin = getOrigin();
      }, 100);
    }
  }

})(
  (typeof global !== 'undefined') ? global
    : ((typeof window !== 'undefined') ? window
    : ((typeof self !== 'undefined') ? self : this))
);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],6:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var undefined;
window._ = {
    defaultTo: function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
    },
    has: function has(object, path) {
        return object != null && Object.prototype.hasOwnProperty.call(object, path);
    },
    isUndefined: function isUndefined(value) {
        return value === undefined;
    },
    isNull: function isNull(value) {
        return value === null;
    },
    isEmpty: function isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) return false;
        }
        return true;
    }
};
window.Ziggy = require('./modules/components/ziggy').Ziggy;

var addCSRFTokenToJqueryAjaxRequest = function addCSRFTokenToJqueryAjaxRequest() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
};
var isSameOrBefore = require('dayjs/plugin/isSameOrBefore');
var utc = require('dayjs/plugin/utc');
var customParseFormat = require('dayjs/plugin/customParseFormat');
var dayjs = require('dayjs');
window.dayjs.extend(customParseFormat);
window.dayjs.extend(utc);
window.dayjs.extend(isSameOrBefore);
// window.moment = window.dayjs
window.SLWeb = function ($) {
    'use strict';

    var options = {};
    var timeouts = [];
    return {
        Components: require('./modules/components'),
        Newsletters: require('./modules/newsletters'),
        Maps: require('./modules/maps'),
        Search: require('./modules/search/search'),
        Guidebook: require('./modules/guidebook'),
        Router: require('./modules/router'),
        MediaUploader: require('./modules/media_uploader'),
        ActivityDates: require('./modules/activities/activity_dates'),
        Events: require('./modules/events'),
        init: function init(appOptions) {
            addCSRFTokenToJqueryAjaxRequest();
            options = appOptions;
            SLWeb.Events.init(SLWeb.config('logging'));
            SLWeb.Guidebook.refreshCounter();
            SLWeb.Components.init(options);
            SLWeb.registerListeners();
        },
        preinit: function preinit(appOptions) {
            appOptions.logging.marketing_cookies_enabled = 0;
            appOptions.logging.analytics_cookies_enabled = 0;
            SLWeb.init(appOptions);
        },
        config: function config(key, defaultValue) {
            if (_.has(options, key)) {
                return options[key];
            }
            return _.defaultTo(defaultValue, null);
        },
        log: function log(subject) {
            if (_.defaultTo(options.debug, false)) {
                console.log(subject);
            }
        },

        waitForAndExcecute: function waitForAndExcecute(condition, callback) {
            var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            if (condition()) {
                callback();
                if (index !== null) {
                    clearTimeout(timeouts[index]);
                }
                return;
            }
            timeouts.push(setTimeout(function () {
                SLWeb.waitForAndExcecute(condition, callback, timeouts.length);
            }, 10));
        },
        roundWithPrecision: function roundWithPrecision(number, precision) {
            var factor = Math.pow(10, _.defaultTo(precision, 2));
            return Math.round(number * factor) / factor;
        },
        numberFormat: function numberFormat(number, precision) {
            return SLWeb.roundWithPrecision(number, precision).toFixed(_.defaultTo(precision, 2)).replace('.', ',');
        },
        makeRandomString: function makeRandomString(maxLength) {
            var stringLength = _.defaultTo(maxLength, 32);
            return (Math.random().toString(36).substring(2) + '' + Math.random().toString(36).substring(2)).substring(0, stringLength);
        },
        lodash: window._,
        unique: function unique(a) {
            var prims = { "boolean": {}, "number": {}, "string": {} };
            var objs = [];

            return a.filter(function (item) {
                var type = typeof item === 'undefined' ? 'undefined' : _typeof(item);
                if (type in prims) {
                    return prims[type].hasOwnProperty(item) ? false : prims[type][item] = true;
                } else {
                    return objs.indexOf(item) >= 0 ? false : objs.push(item);
                }
            });
        },
        registerListeners: function registerListeners() {
            $('.readonly-on-mobile').on('focus', function () {
                $(this).trigger('blur');
            });
        }
    };
}(jQuery);

},{"./modules/activities/activity_dates":9,"./modules/components":10,"./modules/components/ziggy":23,"./modules/events":24,"./modules/guidebook":25,"./modules/maps":26,"./modules/media_uploader":32,"./modules/newsletters":33,"./modules/router":35,"./modules/search/search":36,"dayjs":1,"dayjs/plugin/customParseFormat":2,"dayjs/plugin/isSameOrBefore":3,"dayjs/plugin/utc":4}],7:[function(require,module,exports){
'use strict';

/* global window, module, define, jQuery, require */
/*
 * Bootstrap ColEqualizer v1.1.0
 * https://github.com/megasmack/bootstrap-colequalizer
 */

module.exports = function ($) {
    'use strict';

    var ColEqualizer = window.ColEqualizer || {};

    ColEqualizer = function () {

        function ColEqualizer(element) {

            var _ = this;

            _.el = element;

            _.colHeight(_.el);

            _.winLoad();
        }

        return ColEqualizer;
    }();

    ColEqualizer.prototype.colHeight = function (element) {

        var _ = this;

        $(element).each(function (index, el) {
            _.colReset(el);
            var tallest = 0;
            $('> [class*=col-]', el).each(function (i, e) {
                var testHeight = $(e).height();
                if (testHeight > tallest) {
                    tallest = testHeight;
                }
            });
            $('> [class*=col-]', el).height(tallest);
        });
    };

    ColEqualizer.prototype.colReset = function (el) {

        $('> [class*=col-]', el).height('auto');
    };

    ColEqualizer.prototype.resizeWindow = function () {

        var _ = this;
        var viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        // If set, minWidth shows/hides the nav based on the size of the browser
        // If minWidth not set, nav will always show
        if (768 <= viewWidth) {
            _.colHeight(_.el);
        } else {
            _.colReset(_.el);
        }
    };

    ColEqualizer.prototype.winLoad = function () {

        var _ = this;
        var $win = $(window);

        $win.on('load', function () {
            // Run function on window resize
            $win.on('resize', function () {
                _.resizeWindow();
            });
            // Run function the first time
            _.resizeWindow();
        });
    };

    // jQuery Plugin
    $.fn.colequalizer = function () {

        var _ = this;

        return _.each(function (index, element) {
            element.navinator = new ColEqualizer(element);
        });
    };
};

},{}],8:[function(require,module,exports){
"use strict";

var self = module.exports = function () {
    var config = {};

    var DataStart = 0xFFD8;
    var EXIFMarkerStartExifData = 0xFFE1;
    var EXIFTestTIFFValidity = 0x4949;
    var EXIFImageOrientation = 0x0112;

    var MAX_WIDTH = 1080;
    var MAX_HEIGHT = 1080;
    return {
        init: function init(appConfig) {
            config = appConfig;
        },
        getRotation: function getRotation(file, callback, preview) {
            var reader = new FileReader();
            reader.onload = function (event) {
                var view = new DataView(event.target.result);
                if (view.getUint16(0, false) != DataStart) {
                    return callback(file, preview, -2);
                }
                var length = view.byteLength,
                    offset = 2;
                while (offset < length) {
                    var marker = view.getUint16(offset, false);
                    offset += 2;
                    if (marker == EXIFMarkerStartExifData) {
                        if (view.getUint32(offset += 2, false) != 0x45786966) return callback(file, preview, -1);
                        var little = view.getUint16(offset += 6, false) == EXIFTestTIFFValidity;
                        offset += view.getUint32(offset + 4, little);
                        var tags = view.getUint16(offset, little);
                        offset += 2;
                        for (var i = 0; i < tags; i++) {
                            if (view.getUint16(offset + i * 12, little) == EXIFImageOrientation) {
                                return callback(file, preview, view.getUint16(offset + i * 12 + 8, little));
                            }
                        }
                    } else if ((marker & 0xFF00) != 0xFF00) {
                        break;
                    } else {
                        offset += view.getUint16(offset, false);
                    }
                }
                return callback(file, preview, -1);
            };
            reader.readAsArrayBuffer(file);
        },
        compress: function compress(fileReaderStream, origImg, exifOrientation, file) {
            var width = fileReaderStream.width;
            var height = fileReaderStream.height;
            var result = null;
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext("2d");
            var degrees = 0;
            var portraitCheck = false;
            var auxHeight = height;
            switch (exifOrientation) {
                case 1:
                    // Normal
                    break;
                case 2:
                    // Horizontal flip
                    break;
                case 3:
                    // Rotated 180°
                    degrees = 180;
                    break;
                case 4:
                    // Vertical flip
                    break;
                case 5:
                    // Rotated 90° -> Horizontal flip
                    break;
                case 6:
                    // Rotated 270°
                    degrees = 90;
                    portraitCheck = true;
                    ctx.translate(width / 2, height / 2);
                    height = width;
                    width = auxHeight;
                    break;
                case 7:
                    // Rotated 90° -> Vertical flip
                    break;
                case 8:
                    // Rotated 90°
                    degrees = 270;
                    portraitCheck = true;
                    height = width;
                    width = auxHeight;
                    break;
            }
            // 1,5 mb
            if (width <= MAX_WIDTH && height <= MAX_HEIGHT || file.size <= 1572864) {
                result = file;
            }
            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            } else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
            }
            ctx.canvas.width = width;
            ctx.canvas.height = height;
            if (degrees > 0) {
                ctx.rotate(degrees * Math.PI / 180);
                ctx.translate(0, -width);
                ctx.drawImage(origImg, 0, 0, height, width);
            } else {
                ctx.drawImage(origImg, 0, 0, width, height);
            }
            return canvas.toDataURL();
        }
    };
}();

},{}],9:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    'use strict';

    var config = {};
    // Mock abort in order to avoid problems on the fist call
    var loadingCall = {
        abort: function abort() {}
    };
    var timeoutId = null;
    var timeUntilCalculator = require('../components/time_until_calculator');
    var removeUnusedRowsFromDatepicker = function removeUnusedRowsFromDatepicker() {
        $('#event_dates').find('.datepicker').find('.datepicker-days').find('table').find('tr').each(function (index, element) {
            // If we find an entire row of either new or old dates, we should hide it.
            if ($(element).find('td.new').length == 7) {
                $(element).addClass('hidden');
            }
            if ($(element).find('td.old').length == 7) {
                $(element).addClass('hidden');
            }
        });
    };
    return {
        init: function init(appConfig) {
            config = appConfig || {};
            config['datesEnabled'] = config['datesEnabled'] || [];
            config['loading_date'] = null;
            self.registerElements();
            self.registerListeners();
        },
        registerElements: function registerElements() {
            $('#event_dates').datepicker({
                startDate: dayjs().toDate(),
                todayHighlight: true,
                todayBtn: config.datesEnabled.indexOf(dayjs().startOf('day').utc().unix()) != -1 ? 'linked' : false,
                maxViewMode: 'days',
                minViewMode: 'days',
                language: SLWeb.config('locale'),
                beforeShowDay: function beforeShowDay(date) {
                    // Disable dates that are not enabled ( -\_(-.-)_/- ).
                    if (config.datesEnabled.indexOf(dayjs(date).unix()) == -1) {
                        return false;
                    }
                }
            });
        },
        registerListeners: function registerListeners() {
            $(document).on('click', '.btn-book-date:not(.disabled)', function (event) {
                var fields = $('#book-dates').find('[name^="booking_id"]');
                var someOverZero = false;
                fields.each(function (index, field) {
                    field = $(field);
                    if (parseInt(field.val()) > 0) {
                        someOverZero = true;
                    }
                });
                if (someOverZero) {
                    $('#book-dates').submit();
                }
            });
            $(document).on('change', '#book-dates [name^="booking_id"]', function (event) {
                var fields = $('#book-dates').find('[name^="booking_id"]');
                var someOverZero = false;
                fields.each(function (index, field) {
                    field = $(field);
                    if (parseInt(field.val()) > 0) {
                        someOverZero = true;
                    }
                });
                if (someOverZero) {
                    $('.btn-book-date').removeClass('disabled');
                } else {
                    $('.btn-book-date').addClass('disabled');
                }
            });
            $('#event_dates').datepicker().on('changeDate', function (event) {
                removeUnusedRowsFromDatepicker();
                // Do nothing if date is not enabled.
                if (config.datesEnabled.indexOf(dayjs(event.date).unix()) == -1) {
                    // Select first date
                    $('#event_dates').datepicker('setDate', dayjs.unix(config.datesEnabled[0]).toDate());
                    return;
                }
                $('.btn-book-date').addClass('disabled');
                var date = dayjs(event.date).utc().startOf('day');
                // We only load a date if the date we are loading is different.
                if (config.loading_date !== date.unix()) {
                    config.loading_date = date.unix();
                    loadingCall.abort();
                    if ($('#event_times').find('.loading').length === 0) {
                        $('#event_times').append('\n                            <div class="loading">\n                                <div class="middle">\n                                    <img src="/assets/images/icons/icon-experience.svg" class="heart-pulsate color">\n                                </div>\n                            </div>');
                    }
                    if ($('#event_times').attr('data-date') !== date.unix()) {
                        loadingCall = $.get('/' + SLWeb.config('locale') + '/activities/' + config.id + '/date/times?date=' + dayjs($('#event_dates').datepicker('getUTCDate')).format('YYYY-MM-DD'), function (response) {
                            $('#event_times').attr('data-date', date.unix());
                            $('#event_times').html(response);
                            timeUntilCalculator.init();
                            if ($('#event_times').find('select.tickets-select').length === 0) {
                                $('.btn-book-date').addClass('hidden');
                                $('p.small-note').addClass('hidden');
                            } else {
                                $('.btn-book-date').removeClass('hidden');
                                $('p.small-note').removeClass('hidden');
                            }
                        });
                    }
                }
            });
            $('#event_dates').datepicker('setDate', dayjs.unix(config.datesEnabled[0]).toDate());
            removeUnusedRowsFromDatepicker();
            $('#event_dates').datepicker().on('changeMonth', function () {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(function () {
                    removeUnusedRowsFromDatepicker();
                }, 1);
            });
        }
    };
}(jQuery);

},{"../components/time_until_calculator":21}],10:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    var config = {};
    return {
        feedbackGUI: require('./components/gui/feedback'),
        datesComponent: require('./components/dates'),
        scrollerComponent: require('./components/scroller'),
        gallery: require('./components/gallery'),
        translate: require('./components/translate'),
        ratings: require('./components/ratings'),
        ratingsLoader: require('./components/ratingsLoader'),
        responsiveTabs: require('./components/responsiveTabs'),
        telephoneComponent: require('./components/telephone'),
        fancybox: require('./components/fancybox'),
        promoitemGallery: require('./components/promoitemGallery'),
        colequalizer: require('../compiled/colequalizer'),
        searchBar: require('./search/search_bar'),
        init: function init(appConfig) {
            config = appConfig;
            Dropzone.autoDiscover = false;
            self.searchBar.init();
            // Initializes colequalizer
            self.colequalizer($);
            self.registerComponents();
            self.registerListeners();
            self.registerOnReady();
            self.registerScroller();

            self.feedbackGUI.init();
            self.gallery.init();
            self.translate.init();
            self.responsiveTabs.init();
            self.telephoneComponent.init();
            self.fancybox.init({
                imageLogging: config.logging.images,
                imageShare: config.logging.image_share,
                dataName: 'images'
            });
            self.fancybox.addConfig('offers', self.fancybox.getConfig('images'));
            self.promoitemGallery.init({
                imageLogging: config.logging.images,
                imageShare: config.logging.image_share
            });
            // self.ratings();
            // Foreign components
            SLWeb.Maps.PI.init({
                logging: config.logging.map_articles
            });
        },
        registerComponents: function registerComponents() {
            String.prototype.hashCode = function () {
                var hash = 0;
                var char = null;
                if (this.length == 0) {
                    return hash;
                }
                for (var i = 0; i < this.length; i++) {
                    char = this.charCodeAt(i);
                    hash = (hash << 5) - hash + char;
                    hash = hash & hash; // Convert to 32bit integer
                }
                return hash;
            };
            swal.setDefaults({
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-sm btn-primary',
                cancelButtonClass: 'btn btn-sm btn-secondary'
            });
            $('.read-more-component').readmore({
                speed: 75,
                lessLink: '<a href="#">' + Lang.get("app.readLess") + '</a>',
                moreLink: '<a href="#">' + Lang.get("app.readMore") + '</a>'
            });
        },
        refreshShowMoreComponents: function refreshShowMoreComponents() {
            $('.show-more-component').each(function (index, element) {
                var component = $(element);
                var checkboxesInComponent = component.find('input[type="checkbox"]');
                if (checkboxesInComponent.length > 10 && component.find('input[type="checkbox"]:checked').length == 0) {
                    component.readmore({
                        speed: 75,
                        lessLink: '<a href="#">\n                        <i class="fa fa-caret-up" aria-hidden="true"></i> ' + Lang.get("app.showLess") + '</a>',
                        moreLink: '<a href="#"><i class="fa fa-caret-down" aria-hidden="true">\n                        </i> ' + Lang.get("app.showMore") + '\n                        </a>'
                    });
                } else {
                    component.removeClass('show-more-component');
                }
            });
        },
        registerListeners: function registerListeners() {},
        registerOnReady: function registerOnReady() {
            jQuery(document).ready(function (event) {
                self.doWhenDocumentReady();
            });
        },
        doWhenDocumentReady: function doWhenDocumentReady() {
            var hashForm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            self.datesComponent.init();
            if (hashForm) {
                // Hash forms to detect small changes
                $('form').each(function (i, formElement) {
                    var form = $(formElement);
                    form.attr('data-hash', form.serialize().hashCode());
                });
            }
            $('.hidden-while-loading').removeClass('hidden-while-loading');
            $('body').removeClass('nojQuery');
            $(".selectpicker").selectpicker();
            $('#tabs').tab();
            $("[data-collapse-group='accordion']").click(function () {
                $("[data-collapse-group='accordion']").removeClass('active');
                var $this = $(this);
                $this.addClass('active');
                $("[data-collapse-group='accordion']:not([data-target='" + $this.data("target") + "'])").each(function () {
                    $($(this).data("target")).removeClass("in").addClass('collapse');
                });
            });
            self.activateTooltips();
            $('.dropdown-menu input').click(function () {
                return false;
            });
            $(document).on('click', '.toggle-right-menu:not(.open)', function (event) {
                event.preventDefault();
                var button = $(event.currentTarget);
                button.addClass('open');
                button.find('.menu-icon').addClass('open');
                $("#wrapper").addClass("toggled");
                $("body").addClass("sm-xs-active");
            });
            $(document).on('click', ".toggle-right-menu.open", function (event) {
                event.preventDefault();
                var button = $(event.currentTarget);
                button.removeClass('open');
                button.find('.menu-icon').removeClass('open');
                $("#wrapper").removeClass("toggled");
                $("body").removeClass("sm-xs-active");
            });
            $(document).on('click', ".menu-icon:not(.open)", function (event) {
                event.preventDefault();
                $(event.currentTarget).addClass('open');
                $("#wrapper").addClass("toggled");
                $("body").addClass("sm-xs-active");
            });
            $(document).on('click', ".menu-icon.open", function (event) {
                event.preventDefault();
                $(event.currentTarget).removeClass('open');
                $("#wrapper").removeClass("toggled");
                $("body").removeClass("sm-xs-active");
            });
            $('.btn-fixed').affix({
                offset: {
                    top: 500
                }
            });
            $('.row--eq-height').colequalizer();
            var markRatingCircles = function markRatingCircles(rate) {
                for (var rateIndex = rate; rateIndex > 0; rateIndex--) {
                    $('.give-rating[data-rate="' + rateIndex + '"]').removeClass('icon-rate').addClass('icon-rated');
                }
                for (var _rateIndex = rate + 1; _rateIndex <= 5; _rateIndex++) {
                    $('.give-rating[data-rate="' + _rateIndex + '"]').removeClass('icon-rated').addClass('icon-rate');
                }
            };
            $('.give-rating:not(.disabled)').hover(function (eventIn) {
                var rateElement = $(eventIn.currentTarget);
                var rate = rateElement.data('rate');
                markRatingCircles(rate);
            }, function (eventOut) {
                markRatingCircles(parseInt($('form#give-rating input[name="rating"]').val()));
            });
            $('.give-rating:not(.disabled)').on('click', function (event) {
                var rateElement = $(event.currentTarget);
                var rate = rateElement.data('rate');
                $('form#give-rating input[name="rating"]').val(parseInt(rate));
            });
            SLWeb.Components.refreshShowMoreComponents();
        },
        activateTooltips: function activateTooltips() {
            $('[data-tooltip]').tooltip({
                container: 'body'
            });
            $('[data-tooltip-soa]').tooltip({
                container: 'body',
                html: true,
                template: '<div class="tooltip tooltip--soa" role="tooltip">\n                   <div class="tooltip-arrow"></div>\n                   <div class="tooltip-inner"></div>\n               </div>'
            });
        },
        registerScroller: function registerScroller() {
            self.scrollerComponent.init();
        }
    };
}(jQuery);

},{"../compiled/colequalizer":7,"./components/dates":11,"./components/fancybox":12,"./components/gallery":13,"./components/gui/feedback":14,"./components/promoitemGallery":15,"./components/ratings":16,"./components/ratingsLoader":17,"./components/responsiveTabs":18,"./components/scroller":19,"./components/telephone":20,"./components/translate":22,"./search/search_bar":37}],11:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    var dateFromFormat = function dateFromFormat(date) {
        return dayjs(date, SLWeb.config('moment_date_format')); // Is this the proper format?
    };

    return {
        init: function init() {
            self.registerElements();
            self.registerListeners();
        },
        registerElements: function registerElements() {
            $('#datePicker:not(.birthday), #datePicker2, #datePicker3, #datePicker4,#dateFrom, #dateTo').datepicker({
                format: 'dd.mm.yyyy', //lowercase?
                autoclose: true,
                todayHighlight: true,
                language: SLWeb.config('locale'),
                ignoreReadonly: true,
                startDate: dayjs().toDate()
            });
            $('#datePicker.birthday').datepicker({
                format: 'dd.mm.yyyy', //lowercase?
                autoclose: true,
                language: SLWeb.config('locale'),
                ignoreReadonly: true
            });

            $('.input-daterange').datepicker({
                format: 'dd.mm.yyyy', //lowercase?
                autoclose: true,
                todayHighlight: true,
                language: SLWeb.config('locale'),
                ignoreReadonly: true,
                startDate: dayjs().toDate()
            });
        },
        registerListeners: function registerListeners() {
            $('#dateFrom, #dateTo').datepicker().on('changeDate', function () {
                var datepicker = $(this);
                if (datepicker.data('preceded-by')) {
                    var inputField = $(datepicker.data('preceded-by'));
                    if (inputField.val() === '') {
                        inputField.focus();
                    }
                }
                if (datepicker.data('followed-by')) {
                    var successor = $(datepicker.data('followed-by'));
                    var _inputField = successor;
                    successor.datepicker('setStartDate', dateFromFormat(datepicker.val()).toDate());
                    if (dateFromFormat(_inputField.val()).isSameOrBefore(dateFromFormat(datepicker.val()))) {
                        _inputField.val('');
                    }
                    if (_inputField.val() === '') {
                        _inputField.focus();
                    }
                }
            });
            $('#datePicker, #datePicker2').datepicker().on('changeDate', function () {
                var datepicker = $(this);
                if (datepicker.data('preceded-by')) {
                    var predecessor = $(datepicker.data('preceded-by'));
                    var inputField = predecessor.find('input');
                    if (inputField.val() === '') {
                        inputField.focus();
                    }
                }
                if (datepicker.data('followed-by')) {
                    var successor = $(datepicker.data('followed-by'));
                    var _inputField2 = successor.find('input');
                    successor.datepicker('setStartDate', dateFromFormat(datepicker.find('input').val()).add(1, 'day').toDate());
                    if (dateFromFormat(_inputField2.val()).isSameOrBefore(dateFromFormat(datepicker.find('input').val()))) {
                        _inputField2.val('');
                    }
                    if (_inputField2.val() === '') {
                        _inputField2.focus();
                    }
                }
            });
        },
        quickDate: function quickDate(fieldfrom, fieldto, interval) {

            var d = new Date();
            var year = d.getFullYear();
            var month = d.getMonth() + 1;
            var day = d.getDate();

            if (interval === "today") {
                $("#" + fieldfrom).val(day + "." + month + "." + year);
                $("#" + fieldto).val(day + "." + month + "." + year);
            } else if (interval === "weekend") {

                var friday = new Date(d.getTime());
                friday.setDate(d.getDate() + (7 + 5 - d.getDay()) % 7);
                var fridayyear = friday.getFullYear();
                var fridaymonth = friday.getMonth() + 1;
                var fridayday = friday.getDate();

                var sunday = new Date(d.getTime());
                sunday.setDate(d.getDate() + (7 + 7 - d.getDay()) % 7);
                var sundayyear = sunday.getFullYear();
                var sundaymonth = sunday.getMonth() + 1;
                var sundayday = sunday.getDate();

                $("#" + fieldfrom).val(fridayday + "." + fridaymonth + "." + fridayyear);

                $("#" + fieldto).val(sundayday + "." + sundaymonth + "." + sundayyear);
            } else if (interval === "7d") {

                var newdate = new Date();
                newdate.setDate(newdate.getDate() + 7);

                var newdateyear = newdate.getFullYear();
                var newdatemonth = newdate.getMonth() + 1;
                var newdateday = newdate.getDate();

                $("#" + fieldfrom).val(day + "." + month + "." + year);
                $("#" + fieldto).val(newdateday + "." + newdatemonth + "." + newdateyear);
            }
        }
    };
}(jQuery);

},{}],12:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    var sharedConfig = {};
    var activeMedia = {
        id: null,
        type: null
    };
    var activeFancyboxes = {};
    return {
        init: function init(appConfig) {
            sharedConfig[appConfig.dataName] = appConfig;
            self.registerElements();
            self.registerListeners();
            if (_.isUndefined(sharedConfig[appConfig.dataName].imageLogging)) {
                sharedConfig[appConfig.dataName].imageLogging = SLWeb.config('logging').images;
            }
            if (_.isUndefined(sharedConfig[appConfig.dataName].imageShare)) {
                sharedConfig[appConfig.dataName].imageShare = SLWeb.config('logging').image_share;
            }
        },
        getConfig: function getConfig(dataName) {
            return sharedConfig[dataName];
        },
        addConfig: function addConfig(dataName, configToSet) {
            sharedConfig[dataName] = configToSet;
        },

        registerElements: function registerElements() {},
        setActiveMedia: function setActiveMedia(media) {
            activeMedia = media;
        },
        registerListeners: function registerListeners() {
            var i18n = {};
            i18n[SLWeb.config('locale')] = {
                SHARE: Lang.get('app.share_this_picture'),
                ERROR: Lang.get('app.connection_error')
            };
            $('[data-fancybox]').each(function (index, element) {
                var dataName = $(element).data('fancybox');
                var baseTpl = '<div class="fancybox-container" role="dialog" tabindex="-1">\n                        <div class="fancybox-bg"></div>\n                        <div class="fancybox-inner">\n                            <div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>\n                            <div class="fancybox-toolbar">{{buttons}}</div>\n                            <div class="fancybox-navigation">{{arrows}}</div>\n                            <div class="fancybox-stage"></div>\n                            <div class="fancybox-caption"><div class="fancybox-caption__body"></div></div>\n                        </div>\n                    </div>';
                if (dataName === 'offers') {
                    baseTpl = '\n                    <div class="fancybox-container offer-wrapper" role="dialog" tabindex="-1">\n                        <div class="fancybox-bg"></div>\n                        <div class="fancybox-inner">\n                            <div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>\n                            <div class="fancybox-toolbar">{{buttons}}</div>\n                            <div class="fancybox-navigation">{{arrows}}</div>\n                            <div class="inner-content-wrapper">\n                                <div class="fancybox-stage"></div>\n                                <div class="fancybox-form-wrap"></div>\n                            </div>\n                        </div>\n                    </div>';
                    i18n[SLWeb.config('locale')] = {
                        SHARE: Lang.get('app.share_this_offer')
                    };
                }
                var config = self.getConfig(dataName);
                if (!_.isUndefined(activeFancyboxes[dataName]) && activeFancyboxes[dataName] === true
                // This means we have to wait for a few cycles in order
                // to have the config for this element.
                // if no config found, it falls back to default fancybox config.
                && _.isUndefined(config)) {
                    return;
                }
                activeFancyboxes[dataName] = true;
                $('[data-fancybox="' + dataName + '"]').fancybox({
                    prevEffect: 'none',
                    nextEffect: 'none',
                    baseTpl: baseTpl,
                    closeBtn: true,
                    nextClick: true,
                    buttons: ['share', 'close'],
                    protect: true,
                    clickSlide: false,
                    clickContent: function clickContent(current, event) {
                        return current.type === 'image' ? 'next' : false;
                    },
                    lang: SLWeb.config('locale'),
                    i18n: i18n,
                    onInit: function onInit(instance) {
                        // Prevent background scrolling
                        document.documentElement.style.overflow = 'hidden';
                        document.body.scroll = "no";
                    },
                    beforeShow: function beforeShow(instance, current) {
                        // Find current offer-description element
                        instance.$refs.container.find('.fancybox-form-wrap').children().last().remove();
                        instance.$refs.form = current.opts.$orig.parent().find('.offer-description');

                        // Append offer-description element to the fancybox container
                        instance.$refs.form.clone().appendTo(instance.$refs.container.find('.fancybox-form-wrap'));
                    },
                    afterClose: function afterClose(instance, current) {
                        // Enable background scrolling again
                        document.documentElement.style.overflow = 'scroll';
                        document.body.scroll = "yes";
                    },
                    caption: function caption(current) {
                        var image = $(this);
                        var aggregated = '';
                        if (image.data('entity-link') && !image.data('caption')) {
                            return '<h4><a href="' + image.data('entity-link') + '">' + image.data('entity-name') + '</a></h4>';
                        }
                        if (image.find('.userAvatar').length > 0) {
                            aggregated = image.find('.userAvatar')[0].outerHTML;
                        } else {
                            // Main picture is a user uploaded picture.
                            if (image.closest('.content-c__image').find('.userAvatar').length > 0) {
                                aggregated = image.closest('.content-c__image').find('.userAvatar')[0].outerHTML;
                            }
                        }
                        if (image.data('caption') && image.data('caption').trim().length > 0) {
                            return aggregated + image.data('caption');
                        }

                        return '';
                    },
                    afterShow: function afterShow(current, img) {
                        config = self.getConfig(dataName);
                        var container = img.opts['$orig'][0];
                        var containerOfElements = $('<div class="fancybox-offer-price-container"></div>');
                        $('.fancybox-stage').find('.fancybox-offer-price-container').remove();
                        if (container.dataset.price) {
                            $('.fancybox-stage').find('.fancybox-price').remove();
                            containerOfElements.append('<div class="fancybox-price"><span class="fancybox-price-container">' + container.dataset.price + '</span></div>');
                        }
                        if (container.dataset.offerLinkout) {
                            $('.fancybox-stage').find('.fancybox-offer-linkout').remove();
                            containerOfElements.append('<br /><div class="fancybox-offer-linkout"><a class="btn btn-primary btn-offer-linkout-' + container.dataset.id + '" href="' + container.dataset.offerLinkout + '" target="_blank">' + Lang.get('offers.linkout') + '</a></div>');
                            $(document).off('click', '.btn-offer-linkout-' + container.dataset.id);
                            $(document).on('click', '.btn-offer-linkout-' + container.dataset.id, function (event) {
                                // Log offer linkout
                                SLWeb.Events.log(702, container.dataset.id, 'offers');
                            });
                        }

                        // append this only if price or offerlinkout given
                        if (container.dataset.offerLinkout || container.dataset.price) {
                            $('.fancybox-stage').append(containerOfElements);
                        }

                        if (img.opts.imageid) {
                            var classId = current.current.opts.classid;
                            var id = current.current.opts.id;
                            // || true is there because we want to log everything everytime
                            // Logic could be changed to log 1x per Pageview.
                            if (activeMedia.id !== img.opts.imageid || true) {
                                SLWeb.Events.log(config.imageLogging[classId].typeId, id, config.imageLogging[classId].GACat, config.imageLogging[classId].GAEvent, config.imageLogging[classId].GALabel, function () {}, {
                                    media_id: img.opts.imageid
                                });
                                activeMedia = {
                                    id: img.opts.imageid,
                                    type: config.imageLogging[classId].typeId,
                                    classId: classId,
                                    entityId: id,
                                    dataName: config.dataName
                                };
                            }
                        }
                    }
                });
            });

            $('.fancybox-media').fancybox({
                openEffect: 'none',
                closeEffect: 'none',

                closeBtn: true,
                arrows: true,
                nextClick: true,
                protect: true,
                clickSlide: false,
                buttons: ['share', 'close'],
                helpers: {
                    media: {}
                }
            });
            $(document).on('click', '.fancybox-button--share', function () {
                var config = self.getConfig(activeMedia.dataName);
                SLWeb.Events.log(config.imageShare[activeMedia.classId].typeId, activeMedia.entityId, config.imageShare[activeMedia.classId].GACat, config.imageShare[activeMedia.classId].GAEvent, config.imageShare[activeMedia.classId].GALabel, function () {}, {
                    media_id: activeMedia.id
                });
            });

            $(document).on('click', '.btn-offer-linkout', function () {
                var config = self.getConfig(activeMedia.dataName);
                SLWeb.Events.log(702, activeMedia.entityId, 'offers');
            });
        }
    };
}(jQuery);

},{}],13:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    return {
        init: function init() {
            self.registerElements();
            self.registerListeners();
        },
        registerElements: function registerElements() {},
        registerListeners: function registerListeners() {

            Dropzone.options.myAwesomeDropzone = {
                paramName: "file",
                maxFilesize: 30,
                uploadMultiple: true,
                acceptedFiles: 'image/*',
                parallelUploads: 1,
                maxFiles: 20,
                resizeWidth: 2000,
                dictDefaultMessage: Lang.get('userRate.uploadPicturePlaceholder')
            };
        }
    };
}(jQuery);

},{}],14:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    'use strict';

    var config = {};
    return {
        init: function init(appConfig) {
            config = appConfig || {};
            self.registerElements();
            self.registerListeners();
        },
        registerElements: function registerElements() {},
        registerListeners: function registerListeners() {
            $(document).on('sl-start-loading', function (event) {
                var container = $(event.target);
                if (container.find('.loading').length === 0) {
                    container.append('\n                    <div class="loading">\n                        <div class="middle">\n                            <img src="/assets/images/icons/icon-experience.svg" class="heart-pulsate color">\n                        </div>\n                    </div>');
                }
            });
            $(document).on('sl-end-loading', function (event) {
                $(event.target).find('.loading').remove();
            });
        }
    };
}(jQuery);

},{}],15:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    var config = {};
    var activeEntityId = null;
    var activeClassId = null;
    var activeMedia = {
        id: null,
        type: null
    };
    var getFancyboxImagesFromButtonCode = function getFancyboxImagesFromButtonCode(code, link) {
        var images = JSON.parse(atob(code)).map(function (element, index) {
            return {
                src: element.url_alt.l,
                opts: element
            };
        }).concat([{
            src: '<div class="promoitem-gallery-popup">\n                        <h2>' + Lang.get('accommodation.do_you_like_what_you_see') + '</h2>\n                        <p> <a class="btn btn-highlight btn-block" href="' + link + '">' + Lang.get('accommodation.more_info_pictures') + '</a></p>\n                    </div>\n                ',
            type: 'html'
        }]);
        return images;
    };
    var images = [];
    var i18n = {};
    return {
        init: function init(appConfig) {
            config = appConfig || {};
            i18n[SLWeb.config('locale')] = {
                SHARE: Lang.get('app.share_this_picture')
            };
            self.registerElements();
            self.registerListeners();
        },
        registerElements: function registerElements() {},
        registerListeners: function registerListeners() {
            var captionIndex = 0;
            $('.btn-promoitem-gallery').on('click', function (event) {
                var clickedButton = $(event.currentTarget);
                activeEntityId = clickedButton.data('entity-id');
                activeClassId = clickedButton.data('entity-class');
                images = getFancyboxImagesFromButtonCode(clickedButton.data('gallery-data'), clickedButton.data('entity-link'));
                $.fancybox.open(images, {
                    prevEffect: 'none',
                    nextEffect: 'none',
                    closeBtn: true,
                    arrows: !SLWeb.config('is_mobile', false),
                    nextClick: true,
                    buttons: ['share', 'close'],
                    protect: true,
                    clickSlide: false,
                    clickContent: function clickContent(current, event) {
                        return current.type === 'image' ? 'next' : false;
                    },
                    lang: SLWeb.config('locale'),
                    i18n: i18n,
                    share: {
                        url: function url(instance, item) {
                            return (!instance.currentHash && !(item.type === "inline" || item.type === "html") ? clickedButton.data('entity-link') + '/g#images-' + (item.index + 1) : false) || window.location;
                        }
                    },
                    caption: function caption(current, img) {
                        var image = img.opts;
                        captionIndex++;
                        var aggregated = '';
                        if (clickedButton.data('entity-link') && (image.title || '').length < 1 && !image.user) {
                            return '<h4><a href="' + clickedButton.data('entity-link') + '">' + clickedButton.data('entity-name') + '</a></h4>';
                        }
                        if ((image.title || '').length > 0) {
                            return image.title;
                        }
                        if (_.has(image, 'user') && _.has(image.user.data, 'avatar')) {
                            aggregated = '<img class="user-picture-tooltip userAvatar" data-tooltip="" title="" src="' + image.user.data.avatar.data.url + '" data-original-title=""> \xA9';
                            return aggregated + ' ' + image.user.data.firstname + ' ' + image.user.data.lastname[0] + '.';
                        }
                        return '';
                    },
                    afterShow: function afterShow(current, img) {
                        if (img.opts.id) {
                            // || true is there because we want to log everything everytime
                            // Logic could be changed to log 1x per Pageview.
                            if (activeMedia.id !== img.opts.id || true) {
                                SLWeb.Events.log(config.imageLogging[activeClassId].typeId, activeEntityId, config.imageLogging[activeClassId].GACat, config.imageLogging[activeClassId].GAEvent, config.imageLogging[activeClassId].GALabel, function () {}, {
                                    media_id: current.current.opts.imageid
                                });
                                activeMedia = {
                                    id: img.opts.id,
                                    type: config.imageLogging[activeClassId].typeId,
                                    classId: activeClassId,
                                    entityId: activeEntityId
                                };
                                // We set the global Active media to the actual one.
                                SLWeb.Components.fancybox.setActiveMedia(activeMedia);
                            }
                        }
                    }
                });
            });
        }
    };
}(jQuery);

},{}],16:[function(require,module,exports){
'use strict';

var self = module.exports = function ($, undefined) {
    'use strict';

    var OFFSET = 5;

    function Rating(element, options) {
        this.$input = $(element);
        this.$rating = $('<ul class="list-inline list-rating"></ul>').css({
            cursor: 'default'
        }).insertBefore(this.$input);
        // Merge data and parameter options.
        // Those provided as parameter prevail over the data ones.
        this.options = function (opts) {
            // Sanitize start, stop, step, and fractions.
            // All of them start, stop, and step must be integers.
            opts.start = parseInt(opts.start, 10);
            opts.start = isNaN(opts.start) ? undefined : opts.start;
            // In case we don't have a valid stop rate try to get a reasonable
            // one based on the existence of a valid start rate.
            opts.stop = parseInt(opts.stop, 10);
            opts.stop = isNaN(opts.stop) ? opts.start + OFFSET || undefined : opts.stop;
            // 0 step is ignored.
            opts.step = parseInt(opts.step, 10) || undefined;
            // Symbol fractions and scale (number of significant digits).
            // 0 is ignored and negative numbers are turned to positive.
            opts.fractions = Math.abs(parseInt(opts.fractions, 10)) || undefined;
            opts.scale = Math.abs(parseInt(opts.scale, 10)) || undefined;

            // Extend/Override the default options with those provided either as
            // data attributes or function parameters.
            opts = $.extend({}, $.fn.rating.defaults, opts);
            // Inherit default filled if none is defined for the selected symbol.
            opts.filledSelected = opts.filledSelected || opts.filled;
            return opts;
        }($.extend({}, this.$input.data(), options));

        this._init();
    };

    Rating.prototype = {
        _init: function _init() {
            var rating = this;
            var $input = this.$input;
            var $rating = this.$rating;

            var ifEnabled = function ifEnabled(f) {
                return function (e) {
                    // According to the W3C attribute readonly is not allowed on input
                    // elements with type hidden.
                    // Keep readonly prop for legacy but its use should be deprecated.
                    if (!$input.prop('disabled') && !$input.prop('readonly') && $input.data('readonly') === undefined) {
                        f.call(this, e);
                    }
                };
            };

            // Build the rating control.
            for (var i = 1; i <= this._rateToIndex(this.options.stop); i++) {
                // Create the rating symbol container.
                var $symbol = $('<li class="rating-symbol" aria-hidden="true"></li>').css({
                    position: 'relative'
                });
                // Add background symbol to the symbol container.
                $('<div class="rating-symbol-background ' + this.options.empty + '"></div>').appendTo($symbol);
                // Add foreground symbol to the symbol container.
                // The filled icon is wrapped with a div to allow fractional selection.
                $('<div class="rating-symbol-foreground ' + this.options.filledSelected + '"></div>').css({
                    display: 'inline-block',
                    position: 'absolute',
                    overflow: 'hidden',
                    top: 0,
                    left: 3,
                    // Overspecify right and left to 0 and let the container direction
                    // decide which one is going to take precedence according to the
                    // ltr/rtl direction.
                    // (https://developer.mozilla.org/en-US/docs/Web/CSS/right)
                    // When both the right CSS property and the left CSS property are
                    // defined, the position of the element is overspecified. In that
                    // case, the left value has precedence when the container is
                    // left-to-right (that is that the right computed value is set to
                    // -left), and the right value has precedence when the container is
                    // right-to-left (that is that the left computed value is set to
                    // -right).
                    width: 0
                }).appendTo($symbol);
                $rating.append($symbol);
                this.options.extendSymbol.call($symbol, this._indexToRate(i));
            }
            // Initialize the rating control with the associated input value rate.
            this._updateRate($input.val());

            // Keep rating control and its associated input in sync.
            $input.on('change', function () {
                rating._updateRate($(this).val());
            });

            var fractionalIndex = function fractionalIndex(e) {
                var $symbol = $(e.currentTarget);
                // Calculate the distance from the mouse pointer to the origin of the
                // symbol. We need to be careful with the CSS direction. If we are
                // right-to-left then the symbol starts at the right. So we have to add
                // the symbol width to the left offset to get the CSS right position.
                var x = Math.abs((e.pageX || e.originalEvent.touches[0].pageX) - (($symbol.css('direction') === 'rtl' && $symbol.width()) + $symbol.offset().left));

                // NOTE: When the mouse pointer is close to the left side of the symbol
                // a negative x is returned. Probably some precision error in the
                // calculation.
                // x should never be less than 0 because this would mean that we are in
                // the previous symbol.
                x = x > 0 ? x : rating.options.scale * 0.1;
                return $symbol.index() + x / $symbol.width();
            };
            // Keep the current highlighted index (fractional or not).
            var index = void 0;
            $rating.on('mousedown touchstart', '.rating-symbol', ifEnabled(function (e) {
                // Set input 'trigger' the change event.
                $input.val(rating._indexToRate(fractionalIndex(e))).change();
            })).on('mousemove touchmove', '.rating-symbol', ifEnabled(function (e) {
                var current = rating._roundToFraction(fractionalIndex(e));
                if (current !== index) {
                    // Trigger pseudo rate leave event if the mouse pointer is not
                    // leaving from another symbol (mouseleave).
                    if (index !== undefined) $(this).trigger('rating.rateleave');
                    // Update index and trigger rate enter event.
                    index = current;
                    $(this).trigger('rating.rateenter', [rating._indexToRate(index)]);
                }
                // Fill the symbols as fractions chunks.
                rating._fillUntil(current);
            })).on('mouseleave touchend', '.rating-symbol', ifEnabled(function () {
                // When a symbol is left, reset index and trigger rate leave event.
                index = undefined;
                $(this).trigger('rating.rateleave');
                // Restore on hover out.
                rating._fillUntil(rating._rateToIndex(parseFloat($input.val())));
            }));
        },
        // Fill rating symbols until index.
        _fillUntil: function _fillUntil(index) {
            var $rating = this.$rating;
            // Get the index of the last whole symbol.
            var i = Math.floor(index);
            // Hide completely hidden symbols background.
            $rating.find('.rating-symbol-background').css('visibility', 'visible').slice(0, i).css('visibility', 'hidden');
            var $rates = $rating.find('.rating-symbol-foreground');
            // Reset foreground
            $rates.width(0);
            // Fill all the foreground symbols up to the selected one.
            $rates.slice(0, i).width('auto').find('span').attr('class', this.options.filled);
            // Amend selected symbol.
            $rates.eq(index % 1 ? i : i - 1).find('span').attr('class', this.options.filledSelected);
            // Partially fill the fractional one.
            $rates.eq(i).width(index % 1 * 100 + '%');
        },
        // Calculate the rate of an index according the the start and step.
        _indexToRate: function _indexToRate(index) {
            return Math.min(this.options.start + Math.floor(index) * this.options.step + this.options.step * this._roundToFraction(index % 1), OFFSET);
        },
        // Calculate the corresponding index for a rate.
        _rateToIndex: function _rateToIndex(rate) {
            return (rate - this.options.start) / this.options.step;
        },
        // Round index to the configured opts.fractions.
        _roundToFraction: function _roundToFraction(index) {
            // Get the closest top fraction.
            var fraction = Math.ceil(index % 1 * this.options.fractions) / this.options.fractions;
            // Truncate decimal trying to avoid float precission issues.
            var p = Math.pow(10, this.options.scale);
            return Math.floor(index) + Math.floor(fraction * p) / p;
        },
        // Check the rate is in the proper range [start..stop].
        _contains: function _contains(rate) {
            var start = this.options.step > 0 ? this.options.start : this.options.stop;
            var stop = this.options.step > 0 ? this.options.stop : this.options.start;
            return start <= rate && rate <= stop;
        },
        // Update empty and filled rating symbols according to a rate.
        _updateRate: function _updateRate(rate) {
            var value = parseFloat(rate);
            if (this._contains(value)) {
                this._fillUntil(this._rateToIndex(value));
                this.$input.val(value);
            } else if (rate === '') {
                this._fillUntil(0);
                this.$input.val('');
            }
        },
        rate: function rate(value) {
            if (value === undefined) {
                return this.$input.val();
            }
            this._updateRate(value);
        }
    };

    $.fn.rating = function (options) {
        var args = Array.prototype.slice.call(arguments, 1),
            result = void 0;
        this.each(function () {
            var $input = $(this);
            var rating = $input.data('rating');
            if (!rating) {
                $input.data('rating', rating = new Rating(this, options));
            }
            // Underscore are used for private methods.
            if (typeof options === 'string' && options[0] !== '_') {
                result = rating[options].apply(rating, args);
            }
        });
        return result !== undefined ? result : this;
    };

    // Plugin defaults.
    $.fn.rating.defaults = {
        filled: 'fa fa-circle brand-color',
        filledSelected: undefined,
        empty: 'fa fa-circle',
        start: 0,
        stop: OFFSET,
        step: 1,
        fractions: 1,
        scale: 3,
        extendSymbol: function extendSymbol(rate) {}
    };

    $(function () {
        $('input.rating').rating();
    });
}(jQuery);

},{}],17:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    var config = {};
    return {
        init: function init() {
            var configuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            self.config = configuration;
            self.registerElements();
            self.registerListeners();
        },
        registerElements: function registerElements() {
            $.get('/api/ratings/' + self.config.class + '/' + self.config.id + '?full_view=1').done(function (data) {
                $('#content_ratings').replaceWith(data);
                // console.log(data);
            });
        },
        registerListeners: function registerListeners() {}
    };
}(jQuery);

},{}],18:[function(require,module,exports){
"use strict";

var self = module.exports = function ($) {
    return {
        init: function init() {
            self.registerElements();
        },
        registerElements: function registerElements() {
            window.ResponsiveNav = function (nav, breakPoint) {
                //if no nav container, output an error
                if (typeof nav === "undefined") {
                    SLWeb.log("The nav container needs setting.");
                    return false;
                }

                //elements
                // var navControl = nav.find(".navbar-header").first();
                var mainUL = nav.find("ul#tabs").first();
                var mainLIs = mainUL.children();
                var extraLI = $("<li class='moreButton dropdown'><a href='#' class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>" + Lang.get('app.more') + " <span>&#9662;</span></a>");
                var extraDropdown = $("<ul class='dropdown-menu pull-right'></ul>");
                extraLI.append(extraDropdown);

                //variables
                var siteWidth = $(document).width();
                var navWidth = mainUL.width();
                var usingExtraDropdown = false;

                //listener for screen width
                $(window).resize(function () {
                    siteWidth = $(document).width();
                    navWidth = mainUL.width();
                    checkNavType();
                });

                //added a extra dropdown if not already there
                function addExtraDropdown() {
                    if (!usingExtraDropdown) {
                        usingExtraDropdown = true;
                        mainUL.append(extraLI);
                    }
                }

                //make sure the LIs fit into the nav
                function checkLIsFit() {
                    var widthLIs = 0;

                    mainLIs = mainUL.children();

                    mainLIs.each(function () {
                        widthLIs += $(this).outerWidth(true);
                    });

                    //need a dropdown
                    if (widthLIs > navWidth) {
                        addExtraDropdown();
                        moveLI();
                    }
                }

                //move LIs to the extra dropdown from main nav
                function moveLI() {
                    mainLIs = mainUL.children().not(".moreButton");

                    extraDropdown.prepend(mainLIs.last());

                    checkLIsFit();
                }

                //move all LIs from extra dropdown back to the nav
                function resetExtraDropdown() {
                    usingExtraDropdown = false;

                    var LIsToMove = extraDropdown.children();

                    mainUL.find(".moreButton").remove();

                    mainUL.append(LIsToMove);
                }

                function checkNavType() {
                    if ($(window).width() >= breakPoint) {
                        resetExtraDropdown();
                        checkLIsFit();
                    } else {
                        resetExtraDropdown();
                    }
                }
            };
        }

    };
}(jQuery);

},{}],19:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {

    return {
        init: function init() {
            (function (a) {
                if (/android.+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|e\-|e\/|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(di|rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|xda(\-|2|g)|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
                    $(function () {
                        $('a[href*="#"]:not([href="#"])').click(function () {
                            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                                var target = $(this.hash);
                                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                                if (target.length) {
                                    $('html, body').stop();
                                    $('html, body').animate({
                                        scrollTop: target.offset().top - 70
                                    }, 1000);
                                }
                            }
                        });
                    });
                } else {
                    $(function () {
                        $('a[href*="#"]:not([href="#"])').click(function () {
                            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                                var target = $(this.hash);
                                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                                if (target.length) {
                                    $('html, body').stop();
                                    $('html, body').animate({
                                        scrollTop: target.offset().top - 86
                                    }, 1000);
                                }
                            }
                        });
                    });
                }
            })(navigator.userAgent || navigator.vendor || window.opera);
        }
    };
}(jQuery);

},{}],20:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    function isPhoneHidden(button) {
        return button.find('.number').length > 0;
    }

    return {
        init: function init() {
            self.registerElements();
            self.registerListeners();
        },
        registerElements: function registerElements() {},
        registerListeners: function registerListeners() {
            $(document).on('click', '.telephone-number', function (event) {
                var button = $(event.currentTarget);
                if (!button.attr('data-log')) return;
                var logData = $.parseJSON(window.atob(button.attr('data-log')));
                if (!button.hasClass('shown')) {
                    SLWeb.Events.log(logData.typeId, logData.id, logData.GACat, logData.GAEvent, logData.GALabel);
                }
                if (isPhoneHidden(button)) {

                    var phoneNumber = null;
                    if (button.attr('data-phone')) {
                        phoneNumber = button.data('phone');
                    } else {
                        phoneNumber = button.data('phone-number');
                        if (_.defaultTo(phoneNumber, '').length == 0) {
                            phoneNumber = $(document).find('meta[itemprop="telephone"]').attr('content');
                        }
                        if (button.hasClass('fax')) {
                            phoneNumber = $(document).find('meta[itemprop="faxNumber"]').attr('content');
                        }
                    }

                    button.find('.number').text(phoneNumber);
                    button.addClass('shown');
                }
            });
        }
    };
}(jQuery);

},{}],21:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    'use strict';

    var EACH_MINUTE = 60000;
    var config = {};
    var activeInterval = null;
    var updateTimes = function updateTimes() {
        $('.starts_in').each(function (index, element) {
            var elementDOM = $(element);
            var eventTime = dayjs.unix(elementDOM.data('timestamp'));
            var differenceInSeconds = eventTime.diff(dayjs(), 'seconds');
            var differenceInMinutes = eventTime.diff(dayjs(), 'minutes');
            var differenceInHours = eventTime.diff(dayjs(), 'hours');
            var differenceInDays = eventTime.diff(dayjs(), 'days');
            var timeHTML = '';
            var classToSwitch = '';
            var prependDefaultText = true;
            elementDOM.removeClass('time-30 time-55 time-2h time-3h');
            if (differenceInSeconds <= 59 || eventTime.isBefore(dayjs())) {
                prependDefaultText = false;
                if (elementDOM.data('prepend-lang')) {
                    timeHTML = '' + Lang.get('components.times.zero');
                } else {
                    timeHTML = '<span class="label label-default">' + Lang.get('components.times.zero') + '</span>';
                }
            } else if (differenceInMinutes < 60) {
                if (differenceInMinutes <= 30) {
                    classToSwitch = 'time-30';
                } else if (differenceInMinutes <= 55) {
                    classToSwitch = 'time-55';
                } else {
                    classToSwitch = 'time-2h';
                }
                timeHTML = Lang.choice('components.times.minutes', differenceInMinutes, {
                    time: differenceInMinutes
                });
            } else if (differenceInHours < 24) {
                if (differenceInHours <= 2) {
                    classToSwitch = 'time-2h';
                } else {
                    classToSwitch = 'time-3h';
                }
                timeHTML = Lang.choice('components.times.hours', differenceInHours, {
                    time: differenceInHours
                });
                var minutes = differenceInMinutes - differenceInHours * 60;
                if (minutes > 0) {
                    timeHTML += ' ' + Lang.choice('components.times.minutes', minutes, {
                        time: minutes
                    });
                }
            } else {
                classToSwitch = 'time-3h';
                timeHTML = Lang.get('components.times.days', differenceInDays, {
                    time: differenceInDays
                });
            }
            elementDOM.addClass(classToSwitch);
            elementDOM.html((elementDOM.data('prepend-lang') && prependDefaultText ? elementDOM.data('prepend-lang') + ' ' : '') + timeHTML);
        });
    };
    return {
        init: function init(appConfig) {
            config = appConfig || {};
            self.registerElements();
            self.registerListeners();
        },
        registerElements: function registerElements() {
            // We update the times everytime the clock is on 0.
            var firstInterval = 1000 * (60 - dayjs().second());
            setTimeout(function () {
                updateTimes();
                activeInterval = setInterval(updateTimes, EACH_MINUTE);
            }, firstInterval);
        },
        registerListeners: function registerListeners() {}
    };
}(jQuery);

},{}],22:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    var config = {};
    var translatedEventCount = 0;
    return {
        init: function init(appConfig) {
            config = appConfig;
            self.registerComponents();
            self.registerListeners();
            translatedEventCount = 0;
        },
        registerComponents: function registerComponents() {},
        registerListeners: function registerListeners() {
            $(document).on('click', '.btn-translate-text:not(.disabled)', function (event) {
                var button = $(event.target);
                self.setLoadingStatus(button);
                self.translateElement(button.data('token'));
                $(document).on('sl-web.elementTranslated', function () {
                    self.setNormalStatus(button);
                    button.addClass('disabled');
                });
            });
        },
        translateElement: function translateElement(token) {
            $.post(SLWeb.Router.route('api.post.translate'), {
                'target': SLWeb.config('locale'),
                'token': token
            }, function (response) {
                $(document).trigger('sl-web.elementTranslated');
                if (response.class == 9) {
                    $('h1[itemprop="headline"], .article_title, title').html(response.title);
                    $('.article-teaser').html(response.teaser);
                    $('.description_long').html(response.description_long);

                    // Images loaded with ajax need to be lazy loaded again.
                    $('.lazy').lazy({});
                    return;
                }
                $('[itemprop="description"]#description').html(response.description);
                $('[itemprop="description"].teaser').html(response.teaser);
            });
        },
        setLoadingStatus: function setLoadingStatus(element) {
            element.find('.icon').addClass('hidden');
            element.find('.loading-translation').removeClass('hidden');
        },
        setNormalStatus: function setNormalStatus(element) {
            element.find('.icon').removeClass('hidden');
            element.find('.loading-translation').addClass('hidden');
        }
    };
}(jQuery);

},{}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Ziggy = { "url": "https:\/\/lvh-website.test", "port": null, "defaults": {}, "routes": { "debugbar.openhandler": { "uri": "_debugbar\/open", "methods": ["GET", "HEAD"] }, "debugbar.clockwork": { "uri": "_debugbar\/clockwork\/{id}", "methods": ["GET", "HEAD"] }, "debugbar.telescope": { "uri": "_debugbar\/telescope\/{id}", "methods": ["GET", "HEAD"] }, "debugbar.assets.css": { "uri": "_debugbar\/assets\/stylesheets", "methods": ["GET", "HEAD"] }, "debugbar.assets.js": { "uri": "_debugbar\/assets\/javascript", "methods": ["GET", "HEAD"] }, "debugbar.cache.delete": { "uri": "_debugbar\/cache\/{key}\/{tags?}", "methods": ["DELETE"] }, "dusk.login": { "uri": "_dusk\/login\/{userId}\/{guard?}", "methods": ["GET", "HEAD"] }, "dusk.logout": { "uri": "_dusk\/logout\/{guard?}", "methods": ["GET", "HEAD"] }, "dusk.user": { "uri": "_dusk\/user\/{guard?}", "methods": ["GET", "HEAD"] }, "api.post.media": { "uri": "api\/users\/media\/{entityType}\/{entityId}", "methods": ["POST"] }, "api.log.get": { "uri": "api\/log", "methods": ["GET", "HEAD"] }, "api.log.get.short": { "uri": "api\/l", "methods": ["GET", "HEAD"] }, "api.log.post.short": { "uri": "api\/l", "methods": ["POST"] }, "api.log.post": { "uri": "api\/log", "methods": ["POST"] }, "api.cities.get": { "uri": "api\/cities", "methods": ["GET", "HEAD"] }, "api.guidebook.get": { "uri": "api\/rgb", "methods": ["GET", "HEAD"] }, "api.post.guidebook": { "uri": "api\/guidebook", "methods": ["POST"] }, "api.delete.guidebook": { "uri": "api\/guidebook\/delete", "methods": ["POST"] }, "api.ratings.get": { "uri": "api\/ratings\/{entityClass}\/{entityId}", "methods": ["GET", "HEAD"] }, "api.delete.media": { "uri": "api\/media\/{mediaId}", "methods": ["DELETE"] }, "api.post.translate": { "uri": "api\/translate", "methods": ["POST"] }, "app.user.get": { "uri": "app\/user", "methods": ["GET", "HEAD"] }, "redirect-de.home.get": { "uri": "\/", "methods": ["GET", "HEAD"] }, "redirect-de.newsletter.unsubscribe.get": { "uri": "unsubscribe", "methods": ["GET", "HEAD"] }, "redirect-de.newsletter.unsubscribe.post": { "uri": "unsubscribe", "methods": ["POST"] }, "redirect-de.loc.get": { "uri": "loc", "methods": ["GET", "HEAD"] }, "redirect-de.loc.post": { "uri": "loc", "methods": ["POST"] }, "redirect-de.region.get": { "uri": "{slug}", "methods": ["GET", "HEAD"] }, "redirect-de.store.get": { "uri": "geschaeft\/{slug}", "methods": ["GET", "HEAD"] }, "redirect-de.activity.get": { "uri": "aktivitaet\/{slug}", "methods": ["GET", "HEAD"] }, "redirect-de.activity.booking.get": { "uri": "aktivitaet\/{slug}\/buchung", "methods": ["GET", "HEAD"] }, "redirect-de.event.booking.post": { "uri": "\/", "methods": ["POST"] }, "redirect-de.activity.booking.post": { "uri": "aktivitaet\/{slug}\/buchung", "methods": ["POST"] }, "redirect-de.": { "uri": "activities\/{activityId}\/date\/times", "methods": ["GET", "HEAD"] }, "redirect-de.magazine.article.1.get": { "uri": "magazin\/{categorySlug0}\/{categorySlug1}\/{articleSlug}", "methods": ["GET", "HEAD"] }, "redirect-de.magazine.article.0.get": { "uri": "magazin\/{categorySlug0}\/{articleSlug}", "methods": ["GET", "HEAD"] }, "redirect-de.article.get": { "uri": "magazin\/{slug}", "methods": ["GET", "HEAD"] }, "redirect-de.user.gallery.store.get": { "uri": "geschaeft\/{slug}\/g", "methods": ["GET", "HEAD"] }, "redirect-de.user.rating.activity.get": { "uri": "aktivitaet\/{slug}\/r", "methods": ["GET", "HEAD"] }, "redirect-de.user.rating.activity.delete": { "uri": "aktivitaet\/{slug}\/r", "methods": ["DELETE"] }, "redirect-de.user.rating.activity.post": { "uri": "aktivitaet\/{slug}\/r", "methods": ["POST"] }, "redirect-de.search.get": { "uri": "suche", "methods": ["GET", "HEAD"] }, "redirect-de.guidebook.get": { "uri": "merkliste", "methods": ["GET", "HEAD"] }, "redirect-de.places.list.get": { "uri": "lokalitaeten", "methods": ["GET", "HEAD"] }, "redirect-de.regions.list.get": { "uri": "regionen", "methods": ["GET", "HEAD"] }, "redirect-de.partner.signUp.get": { "uri": "partner\/registrieren", "methods": ["GET", "HEAD"] }, "redirect-de.partner.signUp.post": { "uri": "partner\/registrieren", "methods": ["POST"] }, "redirect-de.internalarticles.imprint.get": { "uri": "impressum", "methods": ["GET", "HEAD"] }, "redirect-de.internalarticles.agb.get": { "uri": "agb", "methods": ["GET", "HEAD"] }, "redirect-de.internalarticles.about_us.get": { "uri": "ueber-uns", "methods": ["GET", "HEAD"] }, "redirect-de.internalarticles.support.get": { "uri": "support", "methods": ["GET", "HEAD"] }, "redirect-de.internalarticles.premium.get": { "uri": "premium-eintrag", "methods": ["GET", "HEAD"] }, "redirect-de.internalarticles.privacy.get": { "uri": "datenschutz", "methods": ["GET", "HEAD"] }, "redirect-de.internalarticles.press.get": { "uri": "presse", "methods": ["GET", "HEAD"] }, "redirect-de.internalarticles.partner.get": { "uri": "partner-werden", "methods": ["GET", "HEAD"] }, "redirect-de.internalarticles.slconnect.get": { "uri": "sl-connect", "methods": ["GET", "HEAD"] }, "redirect-de.user.rating.store.post": { "uri": "geschaeft\/{slug}\/r", "methods": ["POST"] }, "redirect-de.login.get": { "uri": "login", "methods": ["GET", "HEAD"] }, "redirect-de.login.post": { "uri": "login", "methods": ["POST"] }, "redirect-de.socialLogin.post": { "uri": "sociallogin", "methods": ["POST"] }, "redirect-de.signUp.get": { "uri": "registrieren", "methods": ["GET", "HEAD"] }, "redirect-de.signUp.post": { "uri": "registrieren", "methods": ["POST"] }, "redirect-de.signUp.newsletter.get": { "uri": "newsletter", "methods": ["GET", "HEAD"] }, "redirect-de.signUp.newsletter.post": { "uri": "newsletter", "methods": ["POST"] }, "redirect-de.password.forgotten.get": { "uri": "passwort-vergessen", "methods": ["GET", "HEAD"] }, "redirect-de.password.forgotten.post": { "uri": "passwort-vergessen", "methods": ["POST"] }, "redirect-de.password.reset.get": { "uri": "passwort-vergeben", "methods": ["GET", "HEAD"] }, "redirect-de.password.reset.post": { "uri": "passwort-vergeben", "methods": ["POST"] }, "redirect-de.user.get": { "uri": "mein-handwerker", "methods": ["GET", "HEAD"] }, "redirect-de.user.profile.edit.get": { "uri": "mein-handwerker\/profil", "methods": ["GET", "HEAD"] }, "redirect-de.user.profile.edit.post": { "uri": "mein-handwerker\/profil", "methods": ["POST"] }, "redirect-de.user.profile.avatar.post": { "uri": "mein-handwerker\/profil\/avatar", "methods": ["POST"] }, "redirect-de.user.pictures.get": { "uri": "mein-handwerker\/fotos", "methods": ["GET", "HEAD"] }, "redirect-de.user.ratings.get": { "uri": "mein-shopping\/bewertungen", "methods": ["GET", "HEAD"] }, "redirect-de.user.rating.store.delete": { "uri": "geschaeft\/{slug}\/r", "methods": ["DELETE"] }, "redirect-de.user.rating.store.get": { "uri": "geschaeft\/{slug}\/r", "methods": ["GET", "HEAD"] }, "redirect-de.user.guidebook.get": { "uri": "mein-handwerker\/merkliste", "methods": ["GET", "HEAD"] }, "redirect-de.logout.get": { "uri": "logout", "methods": ["GET", "HEAD"] }, "redirect-de.magazine.page.get": { "uri": "magazin\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "redirect-de.home.class.get": { "uri": "{classSlug?}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "redirect-de.region.class.get": { "uri": "{regionSlug}\/{classSlug?}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "redirect-de.region.type.get": { "uri": "{regionSlug}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "redirect-de.region.page.get": { "uri": "{regionSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "redirect-de.region.page.class.get": { "uri": "{regionSlug}\/{classSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "redirect-de.region.page.type1.get": { "uri": "{regionSlug}\/{classSlug}\/{parentTypeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "redirect-de.region.page.type2.get": { "uri": "{regionSlug}\/{classSlug}\/{parentTypeSlug}\/{typeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "redirect-de.city.class.get": { "uri": "{regionSlug}\/{citySlug}\/{classSlug?}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "redirect-de.city.type.get": { "uri": "{regionSlug}\/{citySlug}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "redirect-de.city.page.get": { "uri": "{regionSlug}\/{citySlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "redirect-de.city.page.class.get": { "uri": "{regionSlug}\/{citySlug}\/{classSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "redirect-de.city.page.type1.get": { "uri": "{regionSlug}\/{citySlug}\/{classSlug}\/{parentTypeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "redirect-de.city.page.type2.get": { "uri": "{regionSlug}\/{citySlug}\/{classSlug}\/{parentTypeSlug}\/{typeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "redirect-de.home.type.get": { "uri": "{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "redirect-de.home.page.get": { "uri": "{pageSlug}", "methods": ["GET", "HEAD"] }, "redirect-de.home.page.class.get": { "uri": "{classSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "redirect-de.home.page.type1.get": { "uri": "{classSlug}\/{parentTypeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "redirect-de.home.page.type2.get": { "uri": "{classSlug}\/{parentTypeSlug}\/{typeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "de.home.get": { "uri": "de", "methods": ["GET", "HEAD"] }, "de.newsletter.unsubscribe.get": { "uri": "de\/unsubscribe", "methods": ["GET", "HEAD"] }, "de.newsletter.unsubscribe.post": { "uri": "de\/unsubscribe", "methods": ["POST"] }, "de.loc.get": { "uri": "de\/loc", "methods": ["GET", "HEAD"] }, "de.loc.post": { "uri": "de\/loc", "methods": ["POST"] }, "de.region.get": { "uri": "de\/{slug}", "methods": ["GET", "HEAD"] }, "de.store.get": { "uri": "de\/geschaeft\/{slug}", "methods": ["GET", "HEAD"] }, "de.activity.get": { "uri": "de\/aktivitaet\/{slug}", "methods": ["GET", "HEAD"] }, "de.activity.booking.get": { "uri": "de\/aktivitaet\/{slug}\/buchung", "methods": ["GET", "HEAD"] }, "de.event.booking.post": { "uri": "de", "methods": ["POST"] }, "de.activity.booking.post": { "uri": "de\/aktivitaet\/{slug}\/buchung", "methods": ["POST"] }, "de.": { "uri": "de\/activities\/{activityId}\/date\/times", "methods": ["GET", "HEAD"] }, "de.magazine.article.1.get": { "uri": "de\/magazin\/{categorySlug0}\/{categorySlug1}\/{articleSlug}", "methods": ["GET", "HEAD"] }, "de.magazine.article.0.get": { "uri": "de\/magazin\/{categorySlug0}\/{articleSlug}", "methods": ["GET", "HEAD"] }, "de.article.get": { "uri": "de\/magazin\/{slug}", "methods": ["GET", "HEAD"] }, "de.user.gallery.store.get": { "uri": "de\/geschaeft\/{slug}\/g", "methods": ["GET", "HEAD"] }, "de.user.rating.activity.get": { "uri": "de\/aktivitaet\/{slug}\/r", "methods": ["GET", "HEAD"] }, "de.user.rating.activity.delete": { "uri": "de\/aktivitaet\/{slug}\/r", "methods": ["DELETE"] }, "de.user.rating.activity.post": { "uri": "de\/aktivitaet\/{slug}\/r", "methods": ["POST"] }, "de.search.get": { "uri": "de\/suche", "methods": ["GET", "HEAD"] }, "de.guidebook.get": { "uri": "de\/merkliste", "methods": ["GET", "HEAD"] }, "de.places.list.get": { "uri": "de\/lokalitaeten", "methods": ["GET", "HEAD"] }, "de.regions.list.get": { "uri": "de\/regionen", "methods": ["GET", "HEAD"] }, "de.partner.signUp.get": { "uri": "de\/partner\/registrieren", "methods": ["GET", "HEAD"] }, "de.partner.signUp.post": { "uri": "de\/partner\/registrieren", "methods": ["POST"] }, "de.internalarticles.imprint.get": { "uri": "de\/impressum", "methods": ["GET", "HEAD"] }, "de.internalarticles.agb.get": { "uri": "de\/agb", "methods": ["GET", "HEAD"] }, "de.internalarticles.about_us.get": { "uri": "de\/ueber-uns", "methods": ["GET", "HEAD"] }, "de.internalarticles.support.get": { "uri": "de\/support", "methods": ["GET", "HEAD"] }, "de.internalarticles.premium.get": { "uri": "de\/premium-eintrag", "methods": ["GET", "HEAD"] }, "de.internalarticles.privacy.get": { "uri": "de\/datenschutz", "methods": ["GET", "HEAD"] }, "de.internalarticles.press.get": { "uri": "de\/presse", "methods": ["GET", "HEAD"] }, "de.internalarticles.partner.get": { "uri": "de\/partner-werden", "methods": ["GET", "HEAD"] }, "de.internalarticles.slconnect.get": { "uri": "de\/sl-connect", "methods": ["GET", "HEAD"] }, "de.user.rating.store.post": { "uri": "de\/geschaeft\/{slug}\/r", "methods": ["POST"] }, "de.login.get": { "uri": "de\/login", "methods": ["GET", "HEAD"] }, "de.login.post": { "uri": "de\/login", "methods": ["POST"] }, "de.socialLogin.post": { "uri": "de\/sociallogin", "methods": ["POST"] }, "de.signUp.get": { "uri": "de\/registrieren", "methods": ["GET", "HEAD"] }, "de.signUp.post": { "uri": "de\/registrieren", "methods": ["POST"] }, "de.signUp.newsletter.get": { "uri": "de\/newsletter", "methods": ["GET", "HEAD"] }, "de.signUp.newsletter.post": { "uri": "de\/newsletter", "methods": ["POST"] }, "de.password.forgotten.get": { "uri": "de\/passwort-vergessen", "methods": ["GET", "HEAD"] }, "de.password.forgotten.post": { "uri": "de\/passwort-vergessen", "methods": ["POST"] }, "de.password.reset.get": { "uri": "de\/passwort-vergeben", "methods": ["GET", "HEAD"] }, "de.password.reset.post": { "uri": "de\/passwort-vergeben", "methods": ["POST"] }, "de.user.get": { "uri": "de\/mein-handwerker", "methods": ["GET", "HEAD"] }, "de.user.profile.edit.get": { "uri": "de\/mein-handwerker\/profil", "methods": ["GET", "HEAD"] }, "de.user.profile.edit.post": { "uri": "de\/mein-handwerker\/profil", "methods": ["POST"] }, "de.user.profile.avatar.post": { "uri": "de\/mein-handwerker\/profil\/avatar", "methods": ["POST"] }, "de.user.pictures.get": { "uri": "de\/mein-handwerker\/fotos", "methods": ["GET", "HEAD"] }, "de.user.ratings.get": { "uri": "de\/mein-shopping\/bewertungen", "methods": ["GET", "HEAD"] }, "de.user.rating.store.delete": { "uri": "de\/geschaeft\/{slug}\/r", "methods": ["DELETE"] }, "de.user.rating.store.get": { "uri": "de\/geschaeft\/{slug}\/r", "methods": ["GET", "HEAD"] }, "de.user.guidebook.get": { "uri": "de\/mein-handwerker\/merkliste", "methods": ["GET", "HEAD"] }, "de.logout.get": { "uri": "de\/logout", "methods": ["GET", "HEAD"] }, "de.magazine.page.get": { "uri": "de\/magazin\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "de.home.class.get": { "uri": "de\/{classSlug?}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "de.region.class.get": { "uri": "de\/{regionSlug}\/{classSlug?}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "de.region.type.get": { "uri": "de\/{regionSlug}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "de.region.page.get": { "uri": "de\/{regionSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "de.region.page.class.get": { "uri": "de\/{regionSlug}\/{classSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "de.region.page.type1.get": { "uri": "de\/{regionSlug}\/{classSlug}\/{parentTypeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "de.region.page.type2.get": { "uri": "de\/{regionSlug}\/{classSlug}\/{parentTypeSlug}\/{typeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "de.city.class.get": { "uri": "de\/{regionSlug}\/{citySlug}\/{classSlug?}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "de.city.type.get": { "uri": "de\/{regionSlug}\/{citySlug}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "de.city.page.get": { "uri": "de\/{regionSlug}\/{citySlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "de.city.page.class.get": { "uri": "de\/{regionSlug}\/{citySlug}\/{classSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "de.city.page.type1.get": { "uri": "de\/{regionSlug}\/{citySlug}\/{classSlug}\/{parentTypeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "de.city.page.type2.get": { "uri": "de\/{regionSlug}\/{citySlug}\/{classSlug}\/{parentTypeSlug}\/{typeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "de.home.type.get": { "uri": "de\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "de.home.page.get": { "uri": "de\/{pageSlug}", "methods": ["GET", "HEAD"] }, "de.home.page.class.get": { "uri": "de\/{classSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "de.home.page.type1.get": { "uri": "de\/{classSlug}\/{parentTypeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "de.home.page.type2.get": { "uri": "de\/{classSlug}\/{parentTypeSlug}\/{typeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "it.home.get": { "uri": "it", "methods": ["GET", "HEAD"] }, "it.newsletter.unsubscribe.get": { "uri": "it\/unsubscribe", "methods": ["GET", "HEAD"] }, "it.newsletter.unsubscribe.post": { "uri": "it\/unsubscribe", "methods": ["POST"] }, "it.loc.get": { "uri": "it\/loc", "methods": ["GET", "HEAD"] }, "it.loc.post": { "uri": "it\/loc", "methods": ["POST"] }, "it.region.get": { "uri": "it\/{slug}", "methods": ["GET", "HEAD"] }, "it.store.get": { "uri": "it\/negozio\/{slug}", "methods": ["GET", "HEAD"] }, "it.activity.get": { "uri": "it\/attivita\/{slug}", "methods": ["GET", "HEAD"] }, "it.activity.booking.get": { "uri": "it\/attivita\/{slug}\/prenotazione", "methods": ["GET", "HEAD"] }, "it.event.booking.post": { "uri": "it", "methods": ["POST"] }, "it.activity.booking.post": { "uri": "it\/attivita\/{slug}\/prenotazione", "methods": ["POST"] }, "it.": { "uri": "it\/activities\/{activityId}\/date\/times", "methods": ["GET", "HEAD"] }, "it.magazine.article.1.get": { "uri": "it\/magazine\/{categorySlug0}\/{categorySlug1}\/{articleSlug}", "methods": ["GET", "HEAD"] }, "it.magazine.article.0.get": { "uri": "it\/magazine\/{categorySlug0}\/{articleSlug}", "methods": ["GET", "HEAD"] }, "it.article.get": { "uri": "it\/magazine\/{slug}", "methods": ["GET", "HEAD"] }, "it.user.gallery.store.get": { "uri": "it\/negozio\/{slug}\/g", "methods": ["GET", "HEAD"] }, "it.user.rating.activity.get": { "uri": "it\/attivita\/{slug}\/r", "methods": ["GET", "HEAD"] }, "it.user.rating.activity.delete": { "uri": "it\/attivita\/{slug}\/r", "methods": ["DELETE"] }, "it.user.rating.activity.post": { "uri": "it\/attivita\/{slug}\/r", "methods": ["POST"] }, "it.search.get": { "uri": "it\/ricerca", "methods": ["GET", "HEAD"] }, "it.guidebook.get": { "uri": "it\/preferiti", "methods": ["GET", "HEAD"] }, "it.places.list.get": { "uri": "it\/places", "methods": ["GET", "HEAD"] }, "it.regions.list.get": { "uri": "it\/regioni", "methods": ["GET", "HEAD"] }, "it.partner.signUp.get": { "uri": "it\/partner\/registrazione", "methods": ["GET", "HEAD"] }, "it.partner.signUp.post": { "uri": "it\/partner\/registrazione", "methods": ["POST"] }, "it.internalarticles.imprint.get": { "uri": "it\/chi-siamo", "methods": ["GET", "HEAD"] }, "it.internalarticles.agb.get": { "uri": "it\/condizioni", "methods": ["GET", "HEAD"] }, "it.internalarticles.about_us.get": { "uri": "it\/su-di-noi", "methods": ["GET", "HEAD"] }, "it.internalarticles.support.get": { "uri": "it\/supporto", "methods": ["GET", "HEAD"] }, "it.internalarticles.premium.get": { "uri": "it\/premium", "methods": ["GET", "HEAD"] }, "it.internalarticles.privacy.get": { "uri": "it\/privacy", "methods": ["GET", "HEAD"] }, "it.internalarticles.press.get": { "uri": "it\/press", "methods": ["GET", "HEAD"] }, "it.internalarticles.partner.get": { "uri": "it\/partner", "methods": ["GET", "HEAD"] }, "it.internalarticles.slconnect.get": { "uri": "it\/sl-connect", "methods": ["GET", "HEAD"] }, "it.user.rating.store.post": { "uri": "it\/negozio\/{slug}\/r", "methods": ["POST"] }, "it.login.get": { "uri": "it\/login", "methods": ["GET", "HEAD"] }, "it.login.post": { "uri": "it\/login", "methods": ["POST"] }, "it.socialLogin.post": { "uri": "it\/sociallogin", "methods": ["POST"] }, "it.signUp.get": { "uri": "it\/registrazione", "methods": ["GET", "HEAD"] }, "it.signUp.post": { "uri": "it\/registrazione", "methods": ["POST"] }, "it.signUp.newsletter.get": { "uri": "it\/newsletter", "methods": ["GET", "HEAD"] }, "it.signUp.newsletter.post": { "uri": "it\/newsletter", "methods": ["POST"] }, "it.password.forgotten.get": { "uri": "it\/password-dimenticata", "methods": ["GET", "HEAD"] }, "it.password.forgotten.post": { "uri": "it\/password-dimenticata", "methods": ["POST"] }, "it.password.reset.get": { "uri": "it\/password-assegnata", "methods": ["GET", "HEAD"] }, "it.password.reset.post": { "uri": "it\/password-assegnata", "methods": ["POST"] }, "it.user.get": { "uri": "it\/il-mio-artigiano", "methods": ["GET", "HEAD"] }, "it.user.profile.edit.get": { "uri": "it/\xECl-mio-artigiano/profilo", "methods": ["GET", "HEAD"] }, "it.user.profile.edit.post": { "uri": "it\/il-mio-artigiano\/profilo", "methods": ["POST"] }, "it.user.profile.avatar.post": { "uri": "it\/il-mio-artigiano\/profilo\/avatar", "methods": ["POST"] }, "it.user.pictures.get": { "uri": "it\/il-mio-artigiano\/foto", "methods": ["GET", "HEAD"] }, "it.user.ratings.get": { "uri": "it\/mio-shopping\/ratingo", "methods": ["GET", "HEAD"] }, "it.user.rating.store.delete": { "uri": "it\/negozio\/{slug}\/r", "methods": ["DELETE"] }, "it.user.rating.store.get": { "uri": "it\/negozio\/{slug}\/r", "methods": ["GET", "HEAD"] }, "it.user.guidebook.get": { "uri": "it\/il-mio-artigiano\/preferiti", "methods": ["GET", "HEAD"] }, "it.logout.get": { "uri": "it\/logout", "methods": ["GET", "HEAD"] }, "it.magazine.page.get": { "uri": "it\/magazine\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "it.home.class.get": { "uri": "it\/{classSlug?}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "it.region.class.get": { "uri": "it\/{regionSlug}\/{classSlug?}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "it.region.type.get": { "uri": "it\/{regionSlug}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "it.region.page.get": { "uri": "it\/{regionSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "it.region.page.class.get": { "uri": "it\/{regionSlug}\/{classSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "it.region.page.type1.get": { "uri": "it\/{regionSlug}\/{classSlug}\/{parentTypeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "it.region.page.type2.get": { "uri": "it\/{regionSlug}\/{classSlug}\/{parentTypeSlug}\/{typeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "it.city.class.get": { "uri": "it\/{regionSlug}\/{citySlug}\/{classSlug?}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "it.city.type.get": { "uri": "it\/{regionSlug}\/{citySlug}\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "it.city.page.get": { "uri": "it\/{regionSlug}\/{citySlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "it.city.page.class.get": { "uri": "it\/{regionSlug}\/{citySlug}\/{classSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "it.city.page.type1.get": { "uri": "it\/{regionSlug}\/{citySlug}\/{classSlug}\/{parentTypeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "it.city.page.type2.get": { "uri": "it\/{regionSlug}\/{citySlug}\/{classSlug}\/{parentTypeSlug}\/{typeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "it.home.type.get": { "uri": "it\/{parentTypeSlug?}\/{typeSlug?}", "methods": ["GET", "HEAD"] }, "it.home.page.get": { "uri": "it\/{pageSlug}", "methods": ["GET", "HEAD"] }, "it.home.page.class.get": { "uri": "it\/{classSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "it.home.page.type1.get": { "uri": "it\/{classSlug}\/{parentTypeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "it.home.page.type2.get": { "uri": "it\/{classSlug}\/{parentTypeSlug}\/{typeSlug}\/{pageSlug}", "methods": ["GET", "HEAD"] }, "verify.register": { "uri": "verify\/register", "methods": ["GET", "HEAD"] }, "verify.newsletter": { "uri": "verify\/newsletter", "methods": ["GET", "HEAD"] }, "verify.resetpassword": { "uri": "verify\/resetpassword", "methods": ["GET", "HEAD"] }, "setLanguage": { "uri": "lang\/{locale}", "methods": ["GET", "HEAD"] } } };

if (typeof window !== 'undefined' && typeof window.Ziggy !== 'undefined') {
    Object.assign(Ziggy.routes, window.Ziggy.routes);
}

exports.Ziggy = Ziggy;

},{}],24:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    'use strict';

    var config = void 0;
    var lastLoggedAction = {};
    var LOCAL_STORAGE_KEY = 'slc_uuid';
    var SLC_INITIALIZED = false;
    var setCookie = function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || "") + expires + '; path=/';
    };
    return {
        init: function init(eventsConfig) {
            config = eventsConfig;
            self.registerGoogleTagManagerComponent(false);

            // Set analytics cookies
            if (_.defaultTo(config.analytics_cookies_enabled, true)) {
                if (_.defaultTo(config.hotjar_enabled, true)) {
                    self.registerHotJarComponent();
                }
            }

            // Set marketing cookies
            if (_.defaultTo(config.marketing_cookies_enabled, false)) {} else {
                self.registerGoogleTagManagerComponent(true);
            }
        },
        registerGoogleComponent: function registerGoogleComponent() {
            // GA
            (function (i, s, o, g, r, a, m) {
                i['GoogleAnalyticsObject'] = r;
                i[r] = i[r] || function () {
                    (i[r].q = i[r].q || []).push(arguments);
                }, i[r].l = 1 * new Date();
                a = s.createElement(o), m = s.getElementsByTagName(o)[0];
                a.async = 1;
                a.src = g;
                m.parentNode.insertBefore(a, m);
            })(window, document, 'script', 'https://www.googletagmanager.com/gtag/js?id=' + config.google_ua, 'gtag');
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () {
                dataLayer.push(arguments);
            };
            gtag('js', new Date());
            gtag('config', config.google_ua);
        },
        registerGoogleTagManagerComponent: function registerGoogleTagManagerComponent(personalizedAdsDisabled) {
            // GTM
            (function (w, d, s, l, i) {
                w[l] = w[l] || [];w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l != 'dataLayer' ? '&l=' + l : '';j.async = true;j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', config.google_tag_manager);
        },
        registerSLCComponent: function registerSLCComponent() {
            // SLC
            (function (s, l, c, o) {
                var b = c.createElement('script');b.async = 1;b.src = o;s[l] = s[l] || function () {
                    (s[l].q = s[l].q || []).push(arguments);
                };var r = c.getElementsByTagName('script')[0];
                r.parentNode.insertBefore(b, r);
            })(window, 'SLC', document, 'https://connect.suedtirol.live/slc' + (config.debug ? '_staging' : '') + '.js');
            if (config.location && config.location.lat && config.location.lng) {
                SLC('gl', config.location.lat, config.location.lng);
            }
            if (window.localStorage.getItem(LOCAL_STORAGE_KEY)) {
                // Set a Javascript Cookie with the old localStorage uuid so
                // that in the next request it gets stored in the https cookies.
                setCookie('slc_legacy_ui', window.localStorage.getItem(LOCAL_STORAGE_KEY), 565);
                SLC('ui', window.localStorage.getItem(LOCAL_STORAGE_KEY));
            } else {
                SLC('ui', config.slc_uuid);
            }

            if (config.slc_uie != 0) {
                SLC('uie', config.slc_uie);
            }
            SLC('setup', config.slc_ua);

            if (config.slc_gs_enabled) {
                SLC('gs', function (response) {
                    return response;
                });
            }
        },
        registerHotJarComponent: function registerHotJarComponent() {
            (function (h, o, t, j, a, r) {
                h.hj = h.hj || function () {
                    (h.hj.q = h.hj.q || []).push(arguments);
                };
                h._hjSettings = { hjid: config.hotjar_ua, hjsv: 6 };
                a = o.getElementsByTagName('head')[0];
                r = o.createElement('script');
                r.async = 1;
                r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
                a.appendChild(r);
            })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
        },
        ga: function (_ga) {
            function ga(_x, _x2, _x3) {
                return _ga.apply(this, arguments);
            }

            ga.toString = function () {
                return _ga.toString();
            };

            return ga;
        }(function (ga_event_category, ga_event_action, ga_event_label) {
            if (config.enabled) {
                // Log this event in Google Analytics
                if (!_.isUndefined(ga_event_category) && !_.isUndefined(ga_event_action) && !_.isUndefined(ga_event_label)) {
                    ga('send', 'event', ga_event_category, ga_event_action, ga_event_label);
                }
            }
        }),
        log: function log(action, ref_id, ga_event_category, ga_event_action, ga_event_label, callback, additional) {
            if (config.enabled) {
                // Log this event in Google Analytics
                if (!_.isUndefined(ga_event_category) && !_.isUndefined(ga_event_action) && !_.isUndefined(ga_event_label)) {
                    window.gtag('event', ga_event_category, {
                        action: ga_event_action,
                        label: ga_event_label
                    });
                    SLWeb.log("google event sent:", {
                        cat: ga_event_category,
                        action: ga_event_action,
                        label: ga_event_label
                    });
                }
            }

            // log this on the SL server
            if (additional && additional instanceof Object) {
                /**
                 2 Routes for BC:
                 POST: Log event with additional (object) info
                 GET: Same as before without additional info
                 */
                $.post('/api/l', {
                    action: action,
                    ref_type: ga_event_category,
                    ref_id: ref_id,
                    additional: additional
                }, callback);
            } else {
                $.get("/api/l?action=" + action + "&ref_type=" + ga_event_category + "&ref_id=" + ref_id, callback);
            }
        },
        booking: function booking(placeId, additional, callback) {
            return self.log(config.type_id, placeId, config.gaCat, config.gaEvent, config.gaLabel, callback, additional);
        }
    };
}(jQuery);

},{}],25:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    'use strict';

    return {

        modal: function modal(classification, id, element) {
            if (typeof event !== "undefined") {
                event.preventDefault();
            }

            self.entry.id = id;
            self.entry.classification = classification;
            self.element = element;

            var guidebookAddModal = $('#guidebookAddModal');
            if ($(element).hasClass("in-guidebook")) {
                $('#guidebookRemoveModal').modal();
            } else {
                guidebookAddModal.modal();
            }
            var guidebookModal = guidebookAddModal.find('.modal-body');
            if (!_.defaultTo($(element).data('modal-enabled'), true)) {
                if (guidebookModal.find('.original-body').length === 0) {
                    guidebookModal.wrapInner('<div class="original-body hidden"></div>');
                    guidebookModal.append('<div class="disabled-body">' + Lang.get($(element).data('modal-disabled-text')) + '</div>');
                    guidebookAddModal.find('.btn-add-to-guidebook').addClass('hidden');
                    guidebookAddModal.find('.btn-close-modal').removeClass('hidden');
                }
            } else {
                guidebookModal.find('.original-body').removeClass('hidden');
                guidebookModal.find('.disabled-body').addClass('hidden');
                guidebookAddModal.find('.btn-add-to-guidebook').removeClass('hidden');
                guidebookAddModal.find('.btn-close-modal').addClass('hidden');
            }

            SLWeb.log("guidebook entry:", self.entry);
        },
        refreshCounter: function refreshCounter(element) {

            $.ajax({
                url: '/api/rgb',
                type: 'get',
                dataType: 'json',
                success: function success(data) {

                    // increase guidebook Count
                    $('.guidebookCountMobile').text(data.response);
                    $('.guidebookCountDesktop').text(data.response);

                    // if first like toogle heart in nav
                    if (parseInt($('.guidebookCountDesktop').text()) > 1) {
                        $('.is-heart > i').removeClass('fa-heart-o');
                        $('.is-heart > i').addClass('fa-heart');
                    }
                }
            });
        },
        add: function add(element) {
            if (self.entry.id > 0) {
                if (self.active) {
                    self.active = false;
                    $(element).html('<i class="fa fa-circle-o-notch fa-spin"></i>');
                    self.entry.note = $('#guidebookComment').val();
                    $.ajax({
                        url: '/api/guidebook',
                        type: 'post',
                        dataType: 'json',
                        success: function success(data) {
                            self.active = true;
                            $(element).html(self.locale.addToGuidebookButton);
                            SLWeb.log("data", data);

                            $(self.element).addClass("in-guidebook");
                            $(self.element).find('i').toggleClass('icon-favorite icon-favorite-full');
                            $(self.element).html($(self.element).html().replace(self.locale.addToGuidebook, self.locale.removeFromGuidebook));

                            // increase guidebook Count
                            $('.guidebookCountMobile').text(parseInt($('.guidebookCountMobile').text()) + 1);
                            $('.guidebookCountDesktop').text(parseInt($('.guidebookCountDesktop').text()) + 1);

                            // if first like toogle heart in nav
                            if (parseInt($('.guidebookCountDesktop').text()) == 1) {
                                $('.is-heart > i').toggleClass('icon-favorite icon-favorite-full');
                            }

                            $('#guidebookAddModal').modal("hide");
                        },
                        data: self.entry
                    });
                }
            }
        },
        remove: function remove(element) {
            if (self.entry.id > 0) {
                if (self.active) {
                    self.active = false;
                    $(element).html('<i class="fa fa-circle-o-notch fa-spin"></i>');
                    $.ajax({
                        url: '/api/guidebook/delete',
                        type: 'post',
                        dataType: 'json',
                        success: function success(data) {
                            location.reload();
                        },
                        data: self.entry
                    });
                }
            }
        },
        refresh: function refresh() {
            if (typeof event !== "undefined") {
                event.preventDefault();
            }

            var qp = [];
            $.each($("form[name='guidebook']").serializeArray(), function (i, el) {
                if (el.value && el.value != "") {
                    var name = el.name;
                    if (name.substring(0, 2) == "m-") {
                        name = name.substring(2);
                    }
                    qp.push(name + "=" + encodeURIComponent(el.value));
                }
            });

            var url = SLWeb.Router.route("guidebook.get");

            location.href = url + "?" + SLWeb.unique(qp).join("&");
        },
        entry: {
            classification: 0,
            id: 0,
            note: ""
        },
        locale: {
            addToGuidebook: Lang.get("app.addToGuidebook"),
            addToGuidebookButton: Lang.get("app.addToGuidebookButton"),
            removeFromGuidebook: Lang.get("app.removeFromGuidebook"),
            removeFromGuidebookButton: Lang.get("app.removeFromGuidebookButton")
        },
        element: "",
        active: true

    };
}(jQuery);

},{}],26:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    var options = {};
    var markers = [];
    var lastOpenedInfoWindow = null;
    var openWindowInfo = {};
    var boundaries = null;
    var gmap = null;
    var MarkerAPILoader = require('./maps/markerLoader');
    var isOpen = false;
    var MarkerCluster = {};
    var mapState = {};
    var BLURRED_IMAGE_PATH = 'https://cdn.suedtirol.live/assets/blurred_map_xl.jpg';
    return {
        PI: require('./promoitems_map'),
        Autocomplete: require('./maps/autocomplete'),
        init: function init(mapOptions) {
            options = mapOptions;
            self.alreadyLoaded = true;
            boundaries = new google.maps.LatLngBounds();
            if (mapOptions.deferred) {
                self.alreadyLoaded = false;
                var canvasElement = $(options.canvas);
                canvasElement.css('background-image', 'url(' + BLURRED_IMAGE_PATH + ')');
                canvasElement.css('background-position', 'center');
                canvasElement.css('background-size', 'cover');
                canvasElement.css('cursor', 'pointer');
                canvasElement.css('position', 'relative');
                canvasElement.html('<div style="height: 100%;position: absolute;width: 100%;text-align: center;font-size: 40px;display: table;">\n<span style="display: table-cell;vertical-align: middle;">' + Lang.get('app.enable_google_maps') + '</span></div>');
                if (mapOptions.deferred_element) {
                    canvasElement = $(mapOptions.deferred_element);
                }
                canvasElement.on('click', function (e) {
                    if (!self.alreadyLoaded) {
                        self.alreadyLoaded = true;
                        mapOptions.deferred = false;
                        self.init(mapOptions, callback);
                    }
                });
                return self;
            } else {
                SLWeb.log(options.markers);
                var initMap = function initMap() {
                    var map = new google.maps.Map(options.canvas, {
                        center: self.getLocation(),
                        styles: require('./maps/map_styles'),
                        zoom: $('select[name="order"]').val() == 'geodistance' ? 16 : 10,
                        panControl: false,
                        scaleControl: true,
                        scrollwheel: true,
                        streetViewControl: false,
                        zoomControl: $(options.canvas).closest('#mapContainer').find('#close-map-mobile').length === 0,
                        mapTypeControl: false,
                        clickableIcons: false,
                        mapTypeId: google.maps.MapTypeId.ROADMAP
                    });
                    if (options.location.lat !== null && options.location.lng !== null) {
                        self.setMarkerOnActualLocation(map, options.location.lat, options.location.lng);
                    }
                    gmap = map;
                    if (options.markers) {
                        $.each(options.markers, function (index, marker) {
                            self.setMapsMarker(gmap, marker.lat, marker.lng, marker.headline, marker.street, marker.image, marker.link, marker.price, marker.rating, marker.rating_count, marker.logging, marker.class, marker.id);
                        });
                        self.refreshMap();
                    } else if (self.loadsContentAsyncForced()) {
                        // Load markers from api
                        self.centerOnSouthTyrol();
                        self.loadMarkers();
                    } else if (self.loadsContentAsync()) {
                        self.centerOnSouthTyrol();
                    }
                    $('a[data-target="#mapContainer"]').on('click', function (e) {
                        setTimeout(function () {
                            google.maps.event.trigger(gmap, "resize");
                            gmap.setCenter(self.getLocation());
                            gmap.fitBounds(SLWeb.Maps.getBoundaries());
                        }, 100);
                    });
                    if (callback) {
                        callback();
                    }
                };
                if (mapOptions.deferred === false) {
                    initMap();
                } else {
                    google.maps.event.addDomListener(window, 'load', initMap);
                }
                self.registerListeners();
                return self;
            }
        },
        registerListeners: function registerListeners() {
            $('.btn-center-map').on('click', function (e) {
                SLWeb.Maps.centerMapOnGivenLocation();
            });
        },
        centerOnSouthTyrol: function centerOnSouthTyrol() {
            // Center map on South Tyrol and Zoom.
            // Lat: 46.610550950000004
            // Lng: 11.452981189999946
            gmap.setCenter(new google.maps.LatLng(46.610550950000004, 11.452981189999946));
            gmap.setZoom(10);
        },
        openedInfowindow: function openedInfowindow(infowindow, marker) {
            if (lastOpenedInfoWindow !== null) {
                lastOpenedInfoWindow.close();
            }
            if (marker) {
                openWindowInfo = marker.getData();
            }
            lastOpenedInfoWindow = infowindow;
        },
        loadsContentAsync: function loadsContentAsync() {
            return options.load_markers === 'api';
        },
        loadsContentAsyncForced: function loadsContentAsyncForced() {
            return self.loadsContentAsync() && options.force_on_load === true;
        },
        deleteMarkers: function deleteMarkers() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = markers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var marker = _step.value;

                    marker.getGoogleMarker().setMap(null);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (!_.isEmpty(MarkerCluster)) {
                MarkerCluster.clearMarkers();
            }
            markers = [];
        },
        loadMarkers: function loadMarkers(parameters) {
            var onready = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            MarkerAPILoader.init({
                map: gmap,
                parameters: parameters,
                defaultClass: options.class,
                onready: onready
            }).loadMarkers();
            self.addMarkersToCluster();
        },
        infowindowClosed: function infowindowClosed() {
            lastOpenedInfoWindow = null;
            openWindowInfo = {};
        },
        refreshMap: function refreshMap() {
            google.maps.event.trigger(gmap, "resize");
            gmap.setCenter();
            gmap.fitBounds(SLWeb.Maps.getBoundaries());
        },
        addMarkersToCluster: function addMarkersToCluster() {
            // Add a marker clusterer to manage the markers.
            MarkerClusterer.IMAGE_EXTENSION = "svg";
            MarkerCluster = new MarkerClusterer(gmap, markers.map(function (marker) {
                return marker.getGoogleMarker();
            }), {
                imagePath: '/assets/images/maps/marker-cluster',
                minimumClusterSize: 5
            });
        },
        isInfowindowAlreadyOpen: function isInfowindowAlreadyOpen(marker) {
            if (openWindowInfo && marker) {
                return marker.getData('markerId') == openWindowInfo.markerId && marker.getData('markerClass') == openWindowInfo.markerClass;
            }
            return false;
        },
        getLocation: function getLocation() {
            return new google.maps.LatLng(options.location.lat, options.location.lng);
        },
        setMarkerOnActualLocation: function setMarkerOnActualLocation(map, lat, lng) {
            return new google.maps.Marker({
                position: new google.maps.LatLng(lat, lng),
                map: map,
                icon: '/assets/images/map-marker-current-location.png'
            });
        },

        saveMapState: function saveMapState() {
            var center = gmap.getCenter();
            mapState = {
                zoom: gmap.getZoom(),
                lat: center.lat(),
                lng: center.lng()
            };
        },
        loadMapState: function loadMapState() {
            if (!isNaN(mapState.lat) && !isNaN(mapState.lng) && !isNaN(mapState.zoom)) {
                gmap.setCenter(new google.maps.LatLng(mapState.lat, mapState.lng));
                gmap.setZoom(mapState.zoom);
            }
        },
        centerMap: function centerMap() {
            var center = self.getLocation();
            google.maps.event.trigger(gmap, "resize");
            gmap.panTo(center);
        },
        centerMapOnGivenLocation: function centerMapOnGivenLocation() {
            if (options.location.lat !== null && options.location.lng !== null) {
                self.centerMap(options.location.lat, options.location.lng);
                boundaries.extend(new google.maps.LatLng(options.location.lat, options.location.lng));
                gmap.fitBounds(self.getBoundaries(), 10);
            }
        },
        putMarker: function putMarker(marker) {
            boundaries.extend(marker.getGoogleMarker().getPosition());
            markers.push(marker);
        },
        setMapsMarker: function setMapsMarker(map, lat, long, name, address, imageUrl, link, price, rating, rating_count, logging, markerClass, markerId) {
            var markerGenerator = require('./maps/marker');
            var marker = markerGenerator.generate({
                map: map,
                lat: lat,
                long: long,
                logging: logging,
                markerClass: markerClass,
                markerId: markerId
            });
            self.putMarker(marker);
        },
        getMarkers: function getMarkers() {
            return markers;
        },
        getBoundaries: function getBoundaries() {
            return boundaries;
        },
        fitBoundaries: function fitBoundaries() {
            gmap.fitBounds(self.getBoundaries());
        },
        isOpen: function isOpen() {
            var mapContainer = $('#mapContainer');
            return mapContainer.hasClass('collapse') && mapContainer.hasClass('in');
        },

        isAnyMarkerInBounds: function isAnyMarkerInBounds() {
            var isAnyMarkerInBounds = false;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = markers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var marker = _step2.value;

                    isAnyMarkerInBounds = isAnyMarkerInBounds || gmap.getBounds().contains(marker.getGoogleMarker().getPosition());
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return isAnyMarkerInBounds;
        },
        panTo: function panTo(position) {
            gmap.panTo(position);
        },
        setZoom: function setZoom(level) {
            gmap.setZoom(level);
        },
        setOptions: function setOptions(options, times) {
            if (times >= 35) return;
            if (gmap != null) {
                gmap.setOptions(options);
            }
            setTimeout(function () {
                self.setOptions(options, times++);
            }, 100);
        }
    };
}(jQuery);

},{"./maps/autocomplete":27,"./maps/map_styles":28,"./maps/marker":29,"./maps/markerLoader":31,"./promoitems_map":34}],27:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    var config = {};
    var userHasLocation = function userHasLocation() {
        var location = SLWeb.config('location');
        if (location.lng != null && location.lat != null) {
            var markers = [];
            var icon = {
                url: '/assets/images/map-marker.png'
            };
            var map = window.map;
            var place = {
                name: ""
            };
            var loc = {
                lat: parseFloat(location.lat),
                lng: parseFloat(location.lng)
            };
            // Create a marker for each place.
            markers.push(new google.maps.Marker({
                map: map,
                icon: icon,
                title: place.name,
                position: loc
            }));
        }
    };
    var handleErrors = function handleErrors(error, isMobile) {
        var modal = $("#geoErrorModal");
        modal.find(".modal-content .modal-body h3").html(error.message);

        switch (error.code) {
            case error.PERMISSION_DENIED:
                SLWeb.log("User denied the request for Geolocation.", error);
                if (isMobile) modal.find('.modal-content .modal-body p').html(Lang.get('messages.geolocation.permission_denied_mobile'));else modal.find('.modal-content .modal-body p').html(Lang.get('messages.geolocation.permission_denied_desktop'));
                break;
            case error.POSITION_UNAVAILABLE:
                SLWeb.log("Location information is unavailable.", error);
                modal.find('.modal-content .modal-body p').text(Lang.get('messages.geolocation.position_unavailable'));
                break;
            case error.TIMEOUT:
                SLWeb.log("The request to get user location timed out.", error);
                modal.find('.modal-content .modal-body p').text(Lang.get('messages.geolocation.timeout'));
                break;
            case error.UNKNOWN_ERROR:
                SLWeb.log("An unknown error occurred.", error);
                modal.find('.modal-content .modal-body p').text(Lang.get('messages.geolocation.unknown_error'));
                break;
        }
        modal.modal();
    };
    var getDataForPosition = function getDataForPosition(position) {
        SLWeb.log("position: ", position);
        var geocoder = new google.maps.Geocoder();
        var latlng = {
            lat: parseFloat(position.coords.latitude),
            lng: parseFloat(position.coords.longitude)
        };
        var infowindow = new google.maps.InfoWindow();
        var icon = {
            url: '/assets/images/map-marker.png'
        };
        geocoder.geocode({
            'location': latlng
        }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                    SLWeb.log("detected place:", results[0]);
                    // set input fields
                    $('input[name="lat"]').val(results[0].geometry.location.lat());
                    $('input[name="lng"]').val(results[0].geometry.location.lng());
                    $('#pac-input').val(results[0].formatted_address);
                    var map = window.map;
                    map.setZoom(11);
                    var marker = new google.maps.Marker({
                        position: latlng,
                        icon: icon,
                        map: map
                    });
                    infowindow.setContent(results[1].formatted_address);
                    infowindow.open(map, marker);
                    map.panTo(marker.getPosition());
                } else {
                    window.alert('No results found');
                }
            } else {
                window.alert('Geocoder failed due to: ' + status);
            }
        });
    };
    var coordinates = {};
    return {
        init: function init(appConfig) {

            if ($('input[name="lng"]').val() !== "" && $('input[name="lng"]').val() !== "") {
                $("#savelocation").prop("disabled", false);
            }

            config = appConfig;
            self.registerListeners();
            var location = SLWeb.config('location');
            var map = window.map = new google.maps.Map(document.getElementById('mapFullWidth'), {
                center: {
                    lat: parseFloat(location.lat != null ? location.lat : "46.7341"),
                    lng: parseFloat(location.lng ? location.lng : "11.2888")
                },
                zoom: 9,
                scrollwheel: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });
            // Prevents the user from typing something and
            // Google maps not respoding properly.
            jQuery('#pac-input').prop('disabled', false);
            // Create the search box and link it to the UI element.
            var input = document.getElementById('pac-input');
            var searchBox = new google.maps.places.Autocomplete(input, {
                types: ['geocode']
            });
            // Change viewport based on searchbox results
            map.addListener('bounds_changed', function () {
                searchBox.setBounds(map.getBounds());
            });

            var markers = [];
            // [START region_getplaces]
            // Listen for the event fired when the user selects a prediction and retrieve
            // more details for that place.
            searchBox.addListener('place_changed', function () {
                var place = searchBox.getPlace();

                // Clear out the old markers.
                markers.forEach(function (marker) {
                    marker.setMap(null);
                });
                markers = [];
                var bounds = new google.maps.LatLngBounds();
                SLWeb.log(place.geometry.location.lat(), place.geometry.location.lng());
                SLWeb.log("place: ", place);

                // set hidden fields
                $('input[name="lat"]').val(place.geometry.location.lat());
                coordinates.lat = place.geometry.location.lat();
                coordinates.lng = place.geometry.location.lng();
                $('input[name="lng"]').val(place.geometry.location.lng());
                var icon = {
                    url: '/assets/images/map-marker.png'
                };
                // Create a marker for each place.
                markers.push(new google.maps.Marker({
                    map: map,
                    icon: icon,
                    title: place.name,
                    position: place.geometry.location
                }));
                if (place.geometry.viewport) {
                    // Only geocodes have viewport.
                    bounds.union(place.geometry.viewport);
                } else {
                    bounds.extend(place.geometry.location);
                }
                map.fitBounds(bounds);
                $("#savelocation").prop("disabled", false);
            });
            // [END region_getplaces]
            userHasLocation();
        },
        html5GeoLocation: function html5GeoLocation(isMobile) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(getDataForPosition, function (err) {
                    return handleErrors(err, isMobile);
                });
                $("#savelocation").prop("disabled", false);
            } else {
                SLWeb.log("Geolocation is not supported by this browser.");
            }
        },
        registerListeners: function registerListeners() {
            $(document).on("keypress", 'form[name="locationForm"]', function (event) {
                if (event.keyCode == 13) {
                    event.preventDefault();
                    if ($("#savelocation").prop("disabled") === false) {
                        $('form[name="locationForm"]').submit();
                    }
                }
            });
        }
    };
}(jQuery);

},{}],28:[function(require,module,exports){
"use strict";

module.exports = [{
    "featureType": "administrative.neighborhood",
    "elementType": "geometry.fill",
    "stylers": [{ "visibility": "on" }]
}, {
    "featureType": "administrative.neighborhood",
    "elementType": "labels.text.fill",
    "stylers": [{ "visibility": "on" }]
}, {
    "featureType": "administrative.neighborhood",
    "elementType": "labels.text.stroke",
    "stylers": [{ "visibility": "on" }]
}, {
    "featureType": "landscape.man_made",
    "elementType": "geometry"
}, {
    "featureType": "landscape.natural",
    "elementType": "geometry"
}, {
    "featureType": "landscape.natural.terrain",
    "elementType": "geometry",
    "stylers": [{ "visibility": "on" }]
}, {
    "featureType": "poi",
    "elementType": "labels",
    "stylers": [{ "visibility": "off" }]
}, {
    "featureType": "poi.business",
    "elementType": "all",
    "stylers": [{ "visibility": "off" }]
}, {
    "featureType": "poi.medical",
    "elementType": "geometry"
}, {
    "featureType": "poi.park",
    "elementType": "geometry"
}, {
    "featureType": "road",
    "elementType": "geometry.stroke",
    "stylers": [{ "visibility": "on" }]
}, {
    "featureType": "road",
    "elementType": "labels",
    "stylers": [{ "visibility": "on" }]
}, {
    "featureType": "road.highway",
    "elementType": "geometry.fill"
}, {
    "featureType": "road.highway",
    "elementType": "geometry.stroke"
}, {
    "featureType": "road.arterial",
    "elementType": "geometry.fill"
}, {
    "featureType": "road.local"
}, {
    "featureType": "transit.station.airport",
    "elementType": "geometry.fill"
}, {
    "featureType": "water",
    "elementType": "geometry"
}];

},{}],29:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var self = module.exports = function ($) {
    var config = {};

    var Marker = function () {
        function Marker(data) {
            _classCallCheck(this, Marker);

            this.data = data;
            var markerImage = this.getMarkerIcon();
            var location = new google.maps.LatLng(this.data.lat, this.data.long);
            this.googleMarker = new google.maps.Marker({
                position: location,
                map: this.data.cluster_markers ? function () {
                    return;
                }() : this.data.map,
                custom: location,
                icon: markerImage,
                custom_data: {
                    class: this.data.markerClass,
                    picture: this.data.imageUrl,
                    name: this.data.name,
                    price: this.data.price,
                    address: this.data.address,
                    rating: this.data.ratidatang,
                    rating_count: this.data.rating_count,
                    url: this.data.link,
                    logging: this.data.logging
                }
            });
        }

        _createClass(Marker, [{
            key: 'getMarkerIcon',
            value: function getMarkerIcon() {
                var originalAliases = this.data.aliases || '';
                var aliases = originalAliases.split(',');
                // TODO: Replace with CDN routes
                if (aliases.includes('top-search')) {
                    return '/assets/images/map-marker-top-search.png';
                }
                if (aliases.includes('highlight-search')) {
                    return '/assets/images/map-marker-highlight-search.png';
                }
                return '/assets/images/map-marker.png';
            }
        }, {
            key: 'getGoogleMarker',
            value: function getGoogleMarker() {
                return this.googleMarker;
            }
        }, {
            key: 'getData',
            value: function getData() {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                if (key) {
                    return this.data[key];
                }
                return this.data;
            }
        }]);

        return Marker;
    }();

    return {

        generate: function generate(markerOptions) {
            var marker = new Marker(markerOptions);

            google.maps.event.addListener(marker.getGoogleMarker(), 'click', function () {
                var InfoWindow = require('./markerInfowindow');
                InfoWindow.open(marker);
            });
            google.maps.event.addListener(marker.getGoogleMarker(), 'dblclick', function (e) {
                SLWeb.Maps.setZoom(17);
                SLWeb.Maps.panTo(marker.getGoogleMarker().getPosition());
            });

            return marker;
        }
    };
}(jQuery);

},{"./markerInfowindow":30}],30:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var self = module.exports = function ($) {
    var config = {};
    var FULL_STAR = '<li><i class="sl-icon icon-rating" aria-hidden="true"></i></li>';
    var EMPTY_STAR = '<li><i class="sl-icon icon-rating-o" aria-hidden="true"></i></li>';
    var HALF_STAR = '<li><i class="sl-icon icon-rating-half" aria-hidden="true"></i></li>';
    var InfoWindow = function () {
        function InfoWindow(data) {
            _classCallCheck(this, InfoWindow);

            this.data = data;
        }

        _createClass(InfoWindow, [{
            key: 'generateRatingStars',
            value: function generateRatingStars() {
                var stars = '';
                for (var i = 1; i <= 5; ++i) {
                    if (this.data.rating >= i) {
                        stars += FULL_STAR;
                    } else if (Math.ceil(this.data.rating) === i && typeof this.data.rating == 'number' && Math.floor(this.data.rating) !== this.data.rating) {
                        stars += HALF_STAR;
                    } else {
                        stars += EMPTY_STAR;
                    }
                }
                return '<ul class="catblock__rating list-inline">' + stars + '</ul> (' + this.data.rating_count + ')';
            }
        }, {
            key: 'generatePriceBlock',
            value: function generatePriceBlock() {
                if (this.data.price != null && parseInt(this.data.price) > 0) {
                    return '\n                <div class="is-price">\n                    <strong>' + Lang.get('app.price_from') + '</strong> <span class="price-label">' + this.data.price + '</span>\n                </div>\n                ';
                }
                return '';
            }
        }, {
            key: 'generateSkeleton',
            value: function generateSkeleton(content) {
                return '<div class="mapPopup-c">\n                        <div class="popover-content">\n                            ' + content + '\n                        </div>\n                    </div>';
            }
        }, {
            key: 'generate',
            value: function generate() {
                return this.generateSkeleton('<div class="media">\n                        <div class="media-left media-middle">\n                            <a href="' + this.data.link + '" target="_blank"><img src="' + this.data.image + '" alt="' + this.data.headline + '" class="img-rounded"></a>\n                        </div>\n                        <div class="media-body media-middle">\n                            <h3 class="is-unstyled">' + this.data.headline + '</h3>\n                            ' + (this.data.class !== 7 ? this.generateRatingStars() : '') + '\n                            ' + this.generatePriceBlock() + '\n                            <a href="' + this.data.link + '" class="btn btn-highlight btn-block btn-sm" target="_blank">' + Lang.get('app.view') + '</a>\n                        </div>\n                    </div>');
            }
        }]);

        return InfoWindow;
    }();
    return {
        open: function open(marker) {
            var log = marker.getData('logging');
            if (SLWeb.Maps.isInfowindowAlreadyOpen(marker)) {
                return;
            }
            self.preopenInfoWindowWithLoader(marker);
            $.get('/api/maps/details/' + marker.getData('markerClass') + '/' + marker.getData('markerId'), function (response) {
                // We generate a log action when an infoWindow is shown.
                if (log) {
                    SLWeb.Events.log(log.typeId, log.id, log.GACat);
                }

                // Create a new InfoWindow object.
                var mapInfoWindow = new InfoWindow(response.data);
                var contentString = mapInfoWindow.generate();

                // Create a new Google InfoWindow object.
                var infowindow = new google.maps.InfoWindow({
                    content: contentString,
                    maxWidth: 360
                });

                SLWeb.Maps.openedInfowindow(infowindow, marker);
                infowindow.open(marker.getData('map'), marker.getGoogleMarker());
                google.maps.event.addListener(infowindow, 'closeclick', function () {
                    SLWeb.Maps.infowindowClosed();
                });
            });
        },
        preopenInfoWindowWithLoader: function preopenInfoWindowWithLoader(marker) {
            // Used to give the user an imediate feedback
            // this will simply show an infowindow with a spinner.
            var infowindow = new google.maps.InfoWindow({
                content: '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>',
                maxWidth: 360
            });

            SLWeb.Maps.openedInfowindow(infowindow, null);
            infowindow.open(marker.getData('map'), marker.getGoogleMarker());
        }
    };
}(jQuery);

},{}],31:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    var config = {};
    var getLocationsUrl = function getLocationsUrl() {
        var urlPoly = require('url-polyfill');
        var parametersCandidate = $('input[name="search_query"]').val().trim();
        var urlParameters = new URL(window.location.href).searchParams;
        return '/api/maps/locations?lang=' + Lang.getLocale() + '&' + (config.parameters ? config.parameters : urlParameters.length ? urlParameters : parametersCandidate.length > 0 ? parametersCandidate : '') + '&class=' + config.defaultClass;
    };
    var parseDate = function parseDate(input) {
        if (_.isUndefined(input)) return;

        var parts = input.match(/(\d+)/g);
        // note parts[1]-1
        return new Date(parts[2], parts[1] - 1, parts[0]);
    };
    var renderPriceSlider = function renderPriceSlider() {
        if ($('#priceFilter').length > 0) {
            var prices = $('#priceFilter').val().split(',');
            $("#priceFilter, #priceFilter2").bootstrapSlider({
                tooltip: 'hide',
                min: $('#priceFilter').data('min'),
                max: $('#priceFilter').data('max'),
                range: true,
                value: [parseInt(prices[0]), parseInt(prices[1])]
            });
            $("#priceFilterValue, #priceFilterValue2").text(parseInt(prices[0]) + ' - ' + parseInt(prices[1]) + ' \u20AC');
        }
    };
    return {
        init: function init(appConfig) {
            config = appConfig;

            return self;
        },
        loadMarkers: function loadMarkers() {
            $('#mapContainer').append('\n                <div class="loading">\n                    <div class="middle">\n                        <img src="https://cdn.suedtirol.live/shopping/assets/shplogot.png" class="heart-pulsate color">\n                    </div>\n                </div>');
            $('#formResultsFilter').find('input').each(function (index, element) {
                $(element).prop('disabled', true);
            });
            $.get(getLocationsUrl(), function (response) {
                $('#formResultsFilter').html(response.meta.filters);
                SLWeb.Components.doWhenDocumentReady(false);
                renderPriceSlider();
                $('#datePicker').datepicker('update', parseDate($('#datePicker input').data('default-date')));
                $('#datePicker2').datepicker('update', parseDate($('#datePicker2 input').data('default-date')));
                var markers = response.data;
                for (var index in markers) {
                    var marker = markers[index];
                    var markerGenerator = require('./marker');
                    SLWeb.Maps.putMarker(markerGenerator.generate({
                        map: config.map,
                        lat: marker.latitude,
                        long: marker.longitude,
                        cluster_markers: true,
                        aliases: marker.alias,
                        logging: marker.logging,
                        markerClass: marker.class,
                        markerId: marker.id
                    }));
                }
                SLWeb.Maps.saveMapState();
                SLWeb.Maps.addMarkersToCluster();
                // SLWeb.Maps.refreshMap();
                $('#mapContainer').find('.loading').remove();
                if (config.onready) {
                    config.onready();
                } else {
                    setTimeout(function () {
                        SLWeb.Maps.loadMapState();
                    }, 500);
                }
            });

            //return self;
        }
    };
}(jQuery);

},{"./marker":29,"url-polyfill":5}],32:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    'use strict';

    var options = {};
    var setFileCount = function setFileCount(files) {
        $(options.uploader_selector).attr('data-files-count', parseInt(_.defaultTo($(options.uploader_selector).attr('data-files-count'), 0)) + files.length);
    };
    var images = require('../lib/images');
    return {
        init: function init(mediaOptions) {
            Dropzone.autoDiscover = false;
            options = mediaOptions;
            self.registerElements();
            self.registerListeners();
        },
        registerListeners: function registerListeners() {
            var _this = this;

            // Prevents the browser to open dropped files as new tab
            $(document).on('dragenter', function (e) {
                e.stopPropagation();
                e.preventDefault();
            });
            $(document).on('dragover', function (e) {
                e.stopPropagation();
                e.preventDefault();
            });
            $(document).on('drop', function (e) {
                e.stopPropagation();
                e.preventDefault();
            });
            $(document).on('dragenter', 'body', function (e) {
                e.stopPropagation();
                e.preventDefault();
                $(options.uploader_selector).removeClass('dragenter');
            });
            $(document).on('dragover', 'body', function (e) {
                e.stopPropagation();
                e.preventDefault();
                $(options.uploader_selector).removeClass('dragenter');
            });
            $(document).on('dragenter', options.uploader_selector, function (e) {
                e.stopPropagation();
                e.preventDefault();
                $(options.uploader_selector).addClass('dragenter');
            });
            $(document).on('dragover', options.uploader_selector, function (e) {
                e.stopPropagation();
                e.preventDefault();
            });
            $(document).on('drop', options.uploader_selector, function (e) {
                $(options.uploader_selector).removeClass('dragenter');
                e.preventDefault();
                var files = e.originalEvent.dataTransfer.files;
                setFileCount(files);
                // We need to handle the dropped files (only the first one in this case)
                self.handleDroppedFiles(files, $(_this));
            });
            $(document).on('click', options.uploader_selector, function (e) {
                $("#upload-files").trigger('click');
            });
            $(document).on('change', '#upload-files', function (e) {
                setFileCount(this.files);
                self.handleDroppedFiles(this.files, $(options.uploader_selector));
            });
            $(document).on('click', '.dz-remove', function (event) {
                event.stopPropagation();
                event.preventDefault();
                var link = $(this);
                var mediaId = link.data('media-id');
                var preview = link.closest('.dz-preview');
                var deleteMediaElement = function deleteMediaElement() {
                    var dropzone = preview.closest('.dropzone');
                    if (dropzone.find('.dz-preview').length <= 1) {
                        dropzone.find('.dz-message').removeClass('hidden');
                    }
                    preview.remove();
                };
                if (!_.isUndefined(mediaId) && !_.isNull(mediaId)) {
                    swal({
                        title: Lang.get('app.delete_messages.picture.confirm'),
                        text: Lang.get('app.delete_messages.picture.confirmMessage'),
                        type: 'warning',
                        showCancelButton: true,
                        reverseButtons: true,
                        confirmButtonText: Lang.get('app.delete'),
                        cancelButtonText: Lang.get('app.cancel')
                    }).then(function (result) {
                        if (result.value) {
                            $.ajax({
                                url: '/api/media/' + mediaId,
                                method: 'DELETE',
                                success: function success(response) {
                                    deleteMediaElement();
                                    swal({
                                        title: Lang.get('app.delete_messages.picture.success'),
                                        confirmButtonText: Lang.get('app.close'),
                                        timer: 3000
                                    });
                                }
                            });
                        }
                    });
                } else {
                    deleteMediaElement();
                }
            });
        },

        registerElements: function registerElements() {
            $('<input type="file" multiple id="upload-files"  accept="image/*" class="hidden">').insertBefore(options.uploader_selector);
        },
        handleDroppedFiles: function handleDroppedFiles(files, object) {
            var uploader = $(options.uploader_selector);
            var filesCount = parseInt($(options.uploader_selector).attr('data-files-count'));
            uploader.find('.dz-message').addClass('hidden');
            $.each(files, function (index, file) {
                var previewIdHash = SLWeb.makeRandomString(10);
                var pictureIdHash = SLWeb.makeRandomString(10);
                uploader.append('<div class="dz-preview dz-complete dz-image-preview ' + (options.isMobile ? 'col-xs-6' : '') + '" id="dz-pic-count-' + (previewIdHash + (filesCount + index + 1)) + '"></div>');
                var preview = uploader.find('#dz-pic-count-' + previewIdHash + (filesCount + index + 1));
                var extras = null;
                if (options.directUpload) {
                    extras = '<img src="https://cdn.suedtirol.live/assets/logo/logo_sl_heart_mirror.svg" class="heart-pulsate color">\n                        <div class="computable hidden"><div class="progress">0%</div><div class="percentage">&nbsp;</div></div>\n                        <div class="feedback">\n                            <i data-tooltip title="' + Lang.get('gallery.successUploadTooltip') + '" class="fa fa-check-circle fa-5x fa-inverse feedback-success" aria-hidden="true"></i>\n                            <i data-tooltip title="' + Lang.get('gallery.errorUploadTooltip') + '" class="fa fa-exclamation-circle fa-5x fa-inverse feedback-error" aria-hidden="true"></i>\n                        </div>';
                }
                preview.append('<div class="dz-image">\n                    ' + (extras ? extras : '') + '\n                    <img id="dz-pic-preview-' + (pictureIdHash + (filesCount + index + 1)) + '">\n                    </div>');
                preview.append('<div class="dz-details"><div class="dz-size"><span data-dz-size=""><strong>' + SLWeb.numberFormat(file.size / 1024 / 1024) + '</strong> MB</span></div><div class="dz-filename"><span data-dz-name="">' + file.name + '</span></div></div>');
                preview.append('<a class="dz-remove btn btn-sm ' + (options.directUpload ? 'transparent' : '') + '" data-dz-remove="">' + Lang.get('app.delete') + '</a>');
                self.previewImage(file, preview.find('#dz-pic-preview-' + pictureIdHash + (filesCount + index + 1)));
            });
            SLWeb.Components.activateTooltips();
        },
        compressImage: function compressImage(file, preview, exifOrientation) {
            var origImg = new Image();
            origImg.onload = function () {
                var result = images.compress(this, origImg, exifOrientation, file);
                preview.attr('src', result);
                preview.closest('.image-container').show();
                preview.attr('data-loaded', true);
                if (!options.directUpload) {
                    $(options.uploader_selector).append('<input type="hidden" name="medias[]" value="' + result + '">');
                } else {
                    self.uploadMedia(result, preview.closest('.dz-preview'));
                }
            };
            origImg.src = window.URL.createObjectURL(file);
        },
        uploadMedia: function uploadMedia(media, previewContainer) {
            var hideColourfullFeedback = function hideColourfullFeedback() {
                previewContainer.find('.computable').addClass('hidden');
                previewContainer.find('.heart-pulsate').addClass('hidden');
            };
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                xhr: function xhr() {
                    var xhrRequest = this;
                    var xhr = new window.XMLHttpRequest();
                    xhr.upload.addEventListener("progress", function (event) {
                        if (event.lengthComputable && xhrRequest.data.includes('withProgress=true&')) {
                            previewContainer.find('.computable').attr('class', 'computable');
                            var percentComplete = event.loaded / event.total;
                            percentComplete = parseInt(percentComplete * 100);
                            previewContainer.find('.computable .percentage').width(percentComplete + '%');
                            previewContainer.find('.computable .progress').text(parseInt(percentComplete) + '%');
                            // $('.load-overlay .heart-pulsate').css('filter', 'grayscale(' + (100 - percentComplete) + '%)');
                            if (percentComplete == 100) {
                                previewContainer.find('.computable .progress').text(Lang.get('app.processing'));
                            }
                        }
                    }, false);
                    return xhr;
                },
                beforeSend: function beforeSend(xhr, settings) {
                    xhr.always = function (data, textStatus, jqXHR) {
                        previewContainer.find('.computable').addClass('hidden');
                        previewContainer.find('.computable .percentage').width('0%');
                    };
                    return true;
                }
            });
            $.post(SLWeb.Router.route('api.post.media', {
                entityType: options.entityType,
                entityId: options.entityId
            }), {
                withProgress: true,
                file: media,
                type: 'b64'
            }, function (response) {
                hideColourfullFeedback();
                previewContainer.find('.dz-remove').removeClass('transparent');
                previewContainer.find('.dz-remove').attr('data-media-id', response.id);
                previewContainer.find('.feedback-success').addClass('done');
            }).fail(function () {
                hideColourfullFeedback();
                previewContainer.find('.feedback-error').addClass('occurred');
            });
        },
        previewImage: function previewImage(droppedFile, preview) {
            var file = droppedFile;
            var reader = new FileReader();
            reader.onloadend = function () {
                images.getRotation(file, self.compressImage, preview);
            };
            if (file) {
                reader.readAsDataURL(file); //reads the data as a URL
            } else {
                preview.attr('src', '');
            }
        }
    };
}(jQuery);

},{"../lib/images":8}],33:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    'use strict';

    var config = {};
    return {
        init: function init(appConfig) {
            config = appConfig || {};
            self.registerElements();
            self.registerListeners();
        },
        registerElements: function registerElements() {},
        registerListeners: function registerListeners() {
            $('.btn-unsubscribe').on('click', function (event) {
                $.post(config.url, {
                    token: config.token,
                    email: config.email
                }, function (response) {
                    SLWeb.log(response);
                }).always(function () {
                    window.location.assign($('.btn-cancel').attr('href'));
                });
            });
        }
    };
}(jQuery);

},{}],34:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    var _map = {};
    var config = {};
    return {
        init: function init(appConfig) {
            config = appConfig;
            self.registerElements();
            self.registerListeners();
            if ($('.promoitem-marker[data-mapdata]').length > 0) {
                _map = SLWeb.Maps.init({
                    canvas: document.getElementById('mapFullWidth'),
                    location: SLWeb.config('location'),
                    markers: self.markers()
                });
                SLWeb.log('mapInitialized');
            }
        },
        map: function map() {
            return _map;
        },
        registerListeners: function registerListeners() {
            $('.btn-show-on-map').on('click', function () {
                $('#promoitemMapModal').modal('show');
            });
            $('.btn-give-location').on('click', function (e) {
                SLWeb.Router.goTo(SLWeb.Router.route('loc.get') + '?redirect=' + encodeURI(location.href));
            });
            $('.promoitem-marker[data-mapdata]').on('click', function (event) {
                $('#promoitemMapModal').modal('show');
                // $('.modal-openmap').trigger('click');
                setTimeout(function () {
                    var mapData = jQuery.parseJSON(atob($(event.currentTarget).data('mapdata')));
                    var marker = null;
                    for (var index in _map.getMarkers()) {
                        var mapMarker = _map.getMarkers()[index];
                        if (SLWeb.roundWithPrecision(mapMarker.custom.lat(), 4) == SLWeb.roundWithPrecision(mapData.lat, 4) && SLWeb.roundWithPrecision(mapMarker.custom.lng(), 4) == SLWeb.roundWithPrecision(mapData.lng, 4)) {
                            marker = mapMarker;
                        }
                    };
                    new google.maps.event.trigger(marker, 'click');
                }, 300);
            });
            $("#promoitemMapModal").on("shown.bs.modal", function () {
                SLWeb.log(_map);
                _map.centerMap();
                _map.fitBoundaries();
                google.maps.event.trigger(_map, "resize");
                SLWeb.Events.log(config.logging.typeId, config.logging.refId, config.logging.GACat, config.logging.GAEvent, config.logging.GALabel);
            });
            $("#promoitemMapModal").find('.close-modal').on('click', function () {
                $("#promoitemMapModal").modal('hide');
            });
        },
        registerElements: function registerElements() {
            if ($('.promoitem-marker[data-mapdata]').length > 0) {
                $('.btn-show-on-map').removeClass('hidden');
            }
        },
        markers: function markers() {
            var markers = [];
            $('.promoitem-marker[data-mapdata]').each(function (index, element) {
                var mapData = jQuery.parseJSON(atob($(element).data('mapdata')));
                markers.push(mapData);
            });

            return markers;
        },
        setLogRefId: function setLogRefId(id) {
            config.logging.refId = id;
        }
    };
}(jQuery);

},{}],35:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    'use strict';

    return {
        init: function init() {},
        redirect: function redirect(route, parameters) {
            $.each(parameters, function (slugName, value) {
                route = route.replace(slugName, value);
            });
            window.location.href = route;
        },
        goTo: function goTo(location) {
            window.location.href = location;
        },
        route: function route(routeName, params, isRegularUrl, locale) {
            var baseUrl = null;
            if (_.has(Ziggy.routes, routeName)) {
                baseUrl = Ziggy.routes[routeName].uri;
            } else {
                baseUrl = Ziggy.routes[_.defaultTo(locale, SLWeb.config('locale')) + '.' + routeName].uri;
            }
            /* if (_.defaultTo(isRegularUrl, true) === true) {
                baseUrl = Ziggy.baseUrl + baseUrl;
            } else { */
            baseUrl = "/" + baseUrl;
            // }
            $.each(params, function (param, value) {
                baseUrl = baseUrl.replace("{" + param + "}", value);
            });
            return baseUrl;
        }
    };
}(jQuery);

},{}],36:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    'use strict';

    var options = {};
    var loadMarkersCallback = function loadMarkersCallback() {
        if (!SLWeb.Maps.isAnyMarkerInBounds()) {
            SLWeb.Maps.fitBoundaries();
        } else {
            SLWeb.Maps.fitBoundaries();
        }
    };
    var loadMarkersCallbackOpen = function loadMarkersCallbackOpen() {
        if (!SLWeb.Maps.isAnyMarkerInBounds()) {
            SLWeb.Maps.fitBoundaries();
        } else {
            SLWeb.Maps.loadMapState();
        }
    };
    return {
        init: function init(searchOptions) {
            options = searchOptions;
            self.registerListeners();
        },
        registerListeners: function registerListeners() {
            $(document).ready(function () {
                if (window.location.hash === '#map') {
                    $('.btn-map').trigger('click');
                    $('.btn-map-mobile').trigger('click');
                }
            });
            $(document).on('click', '.btn-query-text', function (event) {
                var button = $(event.currentTarget);
                var url = button.data('new-url');
                SLWeb.Router.goTo(url);
            });
            $(document).on('click', '.apply-search-filters', function (event) {
                self.global(event);
            });
            $(document).on('click', '[data-target="#filterContainer"],[data-target="#sortContainer"],#searchOpenMobile', function (event) {
                // This only applies on mobile
                if (SLWeb.Maps.isOpen()) {
                    $('#mapContainer').removeClass('in');
                    $('#accordion').removeClass('hidden');
                    if ($('.btn-map-mobile').length > 0) {
                        $('.btn-map-mobile').text(Lang.get('search.map'));
                    }
                }
            });
            $(document).on('click', '#searchOpenMobile', function (event) {
                $('#mapContainer').removeClass('in');
                $('#filterContainer').removeClass('in');
                $('#sortContainer').removeClass('in');
                $('.results__header').focus();
            });
            $(document).on('click', '#close-map-mobile', function (event) {
                $('#mapContainer').removeClass('in');
                $('#accordion').removeClass('hidden');
                $('#buttonBarMobile').removeClass('hidden');
            });
            $(document).on('click', '.btn-map, .btn-map-mobile', function (event) {
                var mapContainer = $('#mapContainer');
                var filterBar = $('#filtersidebar');
                var accordionMenu = $('#accordion');
                if (SLWeb.Maps.isOpen()) {
                    // If the form was changed, then apply parameters in search results.
                    // this will produce a redirection.
                    if ($('.btn-map').length > 0) {
                        $('.btn-map').html('<i class="fa fa-map-marker" aria-hidden="true"></i> ' + Lang.get('search.onMap'));
                    }
                    if ($('#buttonBarMobile').length > 0) {
                        $('#buttonBarMobile').removeClass('hidden');
                    }
                    mapContainer.removeClass('in').removeClass('map-fullscreen');
                    filterBar.removeClass('map-fullscreen-filtersidebar');
                    accordionMenu.removeClass('hidden');
                    $('.page_info').removeClass('hidden');
                    if (!$(event.target).hasClass('btn-map-mobile')) {
                        var form = $('#formResultsFilter');
                        if (form.data('hash') != form.serialize().hashCode()) {
                            self.global(event);
                        }
                    }
                } else {
                    $('body').css('overflow', 'hidden');
                    if ($('#buttonBarMobile').length > 0) {
                        $('#buttonBarMobile').addClass('hidden');
                    }
                    if ($('.btn-map').length > 0) {
                        $('.btn-map').html('<i class="fa fa-chevron-left" aria-hidden="true"></i> ' + Lang.get('search.toList'));
                    }
                    if ($(document).height() <= 1900) {
                        $(window).off('.affix');
                        $('#mapContainer').removeData('affix').removeClass('affix affix-top affix-bottom');
                        $('#mapContainer').removeClass('affix-bottom').attr('data-offset-bottom', '').attr('data-spy', null).attr('style', '');
                        $(window).scrollTop($(window).scrollTop() + 1);
                        $(window).scrollTop($(window).scrollTop() - 1);
                    }
                    if (SLWeb.Maps.loadsContentAsync()) {
                        // Load markers from api
                        SLWeb.Maps.deleteMarkers();
                        SLWeb.Maps.loadMarkers(function () {
                            if ($('input[name="originalQuery"]').length > 0) {
                                return $('input[name="originalQuery"]').val();
                            }
                            return;
                        }(), loadMarkersCallback);
                    }
                    $('.page_info').addClass('hidden');
                    mapContainer.addClass('in');
                    mapContainer.css('height', $(window).height() - ($('.navbar-fixed-top').height() + _.defaultTo($('.content-c__tabsnav').height(), 0) + _.defaultTo($('.content-c__mobile--resultnav').height(), 0) + _.defaultTo($('.result-count-location-container').height(), 0)));
                    mapContainer.css('width', $(window).width() - mapContainer.position().left);
                }
            });
            $(window).resize(function () {
                if (SLWeb.Maps.isOpen()) {
                    var mapContainer = $('#mapContainer');
                    mapContainer.css('height', $(window).height() - ($('.navbar-fixed-top').height() + _.defaultTo($('.content-c__tabsnav').height(), 0)));
                    mapContainer.css('width', $(window).width() - mapContainer.position().left);
                }
            });
            $(document).on('change', 'input.open-time', function () {
                var radio = $(this);
                var opentimeContainer = $('div.opentime-container');
                if (radio.attr('id') == 'cb-open-time' && radio.prop('checked')) {
                    opentimeContainer.removeClass('hidden');
                    $('.opentime-apply-btn-container').removeClass('hidden');
                    opentimeContainer.find('#day').prop('disabled', false).change();
                    opentimeContainer.find('.bootstrap-select').removeClass('disabled');
                    opentimeContainer.find('.dropdown-toggle').removeClass('disabled');
                    opentimeContainer.find('#time').prop('disabled', false);
                } else {
                    opentimeContainer.addClass('hidden');
                    $('.opentime-apply-btn-container').addClass('hidden');
                    opentimeContainer.find('#day').prop('disabled', true).change();
                    opentimeContainer.find('#time').prop('disabled', true);
                    self.global();
                }
            });
        },
        global: function global(event, redirect) {
            if (!_.isUndefined(event)) {
                event.preventDefault();
            }
            var queryParameters = [];
            $.each($('form[name="search"]').serializeArray(), function (i, formElement) {
                if (formElement.value && formElement.value !== "") {
                    if (formElement.name === 'filter[pricefrom]') {
                        var element = $('form[name="search"]').find('input[name="' + formElement.name + '"]');
                        if (element.val() === element.data('min') + ',' + element.data('max')) {
                            return;
                        }
                    }
                    var name = formElement.name;
                    if (name.substring(0, 2) === "m-") {
                        name = name.substring(2);
                    }
                    queryParameters.push(name + "=" + encodeURIComponent(formElement.value));
                }
            });
            var parameters = SLWeb.unique(queryParameters).join("&");
            var newLocation = SLWeb.Router.route('search.get') + "?" + parameters;
            if (SLWeb.Maps.isOpen() && SLWeb.Maps.loadsContentAsync()) {
                SLWeb.Maps.deleteMarkers();
                SLWeb.Maps.loadMarkers(parameters, loadMarkersCallbackOpen);
                window.history.pushState(null, '', newLocation + '#map');
            } else if (_.defaultTo(redirect, true)) {
                $('body').trigger('sl-start-loading');
                location.href = newLocation;
            }
            return newLocation;
        },
        resetOpenTime: function resetOpenTime(button, type, otherboxes) {
            $('#cb-open-now').prop('checked', true).change();
            $('#cb-open-now').prop('checked', false).change();

            if (type && type === 'guidebook') {
                SLWeb.Guidebook.refresh();
            } else {
                self.global();
            }
        },
        resetCheckboxes: function resetCheckboxes(element, type, otherboxes) {
            //TODO: clean this code
            $.each($(element).parent().parent().find('input[type=checkbox]:checked'), function (i, el) {
                SLWeb.log(el);
                if (el.id.substring(0, 2) === "m-") {
                    $(el).removeAttr('checked');
                    $("#" + el.id.substring(2)).removeAttr('checked');
                } else {
                    $(el).removeAttr('checked');
                    $("#m-" + el.id).removeAttr('checked');
                }
            });
            if (otherboxes) {
                $.each($("#" + otherboxes).find('input[type=checkbox]:checked'), function (i, el) {
                    SLWeb.log(el);
                    if (el.id.substring(0, 2) === "m-") {
                        $(el).removeAttr('checked');
                        $("#" + el.id.substring(2)).removeAttr('checked');
                    } else {
                        $(el).removeAttr('checked');
                        $("#m-" + el.id).removeAttr('checked');
                    }
                });
            }
            if (type && type === 'guidebook') {
                SLWeb.Guidebook.refresh();
            } else {
                self.global();
            }
        },
        resetPriceFilter: function resetPriceFilter(event, dontDoSearch) {
            if (_.isUndefined(dontDoSearch)) {
                event.preventDefault();
            }
            var priceFilterElement = $("#priceFilter");
            var min = priceFilterElement.data('value').split(",")[0];
            var max = priceFilterElement.data('value').split(",")[1];
            $("#priceFilterValue, #priceFilterValue2").text(min + " - " + max + ' €');
            priceFilterElement.slider('setValue', [min, max]);
            $("#priceFilter2").slider('setValue', [min, max]);
            $('input[name="filter[pricefrom]"]').val('');
            if (_.isUndefined(dontDoSearch)) {
                self.global();
            }
        }
    };
}(jQuery);

},{}],37:[function(require,module,exports){
'use strict';

var self = module.exports = function ($) {
    'use strict';

    var config = {};
    return {
        init: function init(appConfig) {
            config = appConfig || {};
            self.registerElements();
            self.registerListeners();
        },
        registerElements: function registerElements() {
            if ($('input[name="only_soa"]').val() == 1) {
                var form = $('input[name="only_soa"]').closest('form');
                if (form.find('input.soa-category').length === 0) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = SLWeb.config('soa_category')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var typeId = _step.value;

                            form.append('<input type="hidden" value="' + typeId + '" name="filter[soa-certified][]" class="soa-category">');
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        },
        clearSOA: function clearSOA() {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = SLWeb.config('soa_category')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var typeId = _step2.value;

                    $('input[type="hidden"][name="only_soa"]').remove();
                    $('input[type="hidden"][value="' + typeId + '"][name="filter[soa-certified][]"]').remove();
                    $('input[type="checkbox"][value="' + typeId + '"][name="filter[soa-certified][]"]').removeAttr('checked');
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        },
        registerListeners: function registerListeners() {
            $('.form--search-box').on('click', function (event) {
                var button = $('#searchOpenMobile');
                var container = button.closest('li');
                if (!container.hasClass('open')) {
                    container.addClass('open');
                    SLWeb.waitForAndExcecute(function () {
                        return $('#searchFieldMobile').is(':visible');
                    }, function () {
                        $('#searchFieldMobile').click().focus();
                    });
                    event.stopPropagation();
                }
            });
            $(document).on('click b-click', '.soa-checkbox,.soa_placeholder', function (event) {
                var checkbox = $('input[name="only_soa"]');
                var form = checkbox.closest('form');
                if (checkbox.val() == 1) {
                    checkbox.val(0);
                    form.find('.soa-category').remove();
                    $('.soa-checkbox').removeClass('icon-rated').addClass('icon-rate');
                } else {
                    checkbox.val(1);
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = SLWeb.config('soa_category')[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var typeId = _step3.value;

                            form.append('<input type="hidden" value="' + typeId + '" name="filter[soa-certified][]" class="soa-category">');
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }

                    $('.soa-checkbox').addClass('icon-rated').removeClass('icon-rate');
                }
            });
        }
    };
}(jQuery);

},{}]},{},[6]);

//# sourceMappingURL=temp_main_app.js.map
